<!-- компонент Update: форма редактирования -->
<template>
	
	<div v-if="this.$store.state.is_auth" class="w5-form-wrapper">

		<template v-if="!form_ErrorMessage">

			<!-- блок с локальным сообщением об ошибке -->
			<transition name="fadeControl" key="transitionError">
				<div v-show="localErrorMessage !== ''" class="alert alert-danger font-size-90 margin-top-15" role="alert" style="margin-right: 10px">
					<button @click="localErrorMessage = ''" class="close" :title="'main/close' | ftc">×</button>
					<span style="padding:0;margin:0;" v-withSafeTags="localeFtc(localErrorMessage)"></span>
				</div>
			</transition>
			
			<!-- заголовок -->
			<h3>{{ formData.title | ftc }}</h3>

			<!-- информация по платежам -->
			<div v-if="crud === 'operation' && action === 'create' && $store.state.user_type === 'client'" class="w5-block-bordered">
				<p v-withSafeTags="localeFtc('operation/bonus_information')" class="w5-block-bordered-text"></p>
			</div>

			<!-- доп.информация -->
			<div v-if="showAdditionalInfo" class="w5-form-additional-info">
				<span v-if="formInfo.max" class="pull-left">{{ 'main/available_to_order' | ftc }}: <strong>{{ formInfo.max }}</strong><span v-if="formInfo.for"> {{ formInfo.for | ftc }}</span></span>
				<span v-if="formInfo.cost" class="pull-right">{{ 'servicetype/cost' | ftc }}: <strong>{{ formInfo.cost }}</strong> <span v-withSafeTags="localeFtc('main/ruble')"></span><span v-if="formInfo.period"> / {{ formInfo.period | ftc }}</span><span v-if="crud === 'disks' && formInfo.for"> / 1 {{ formInfo.for | ftc }}</span></span>
				<span class="clearfix"></span>
			</div>
						
			<!-- форма редактирования -->
			<form class="w5-from" :class="{ 'form-with-divider': isFormWithDivider }" autocomplete="off"><fieldset :disabled="(form_Loading || isFormLocked) && !outerDiskRequestType">

				<!-- поля -->
				<div v-for="(row, index) in formData.fields"
					v-if="row"
					:key="index"
					:class="{
						'w5-form-row': isVisibleField(row),
						'with-number-divider': isFormWithNumberDivider,
						'divider-field': isDividerField(row)
					}">
					<Field v-for="field in row"
						:key="field._field_name"
						:ref="field._field_name"
						:isVisibleRow="isVisibleField(row)"
						:countVisibleFieldsInRow="countVisibleFieldsInRow(row)"
						:objID="id"
						:crud="crud"
						:action="action"
						:Field="field"
						:listBlockToOut="crud === 'domains' && field._field_name === 'plan_id' ? false : true"
						:linkHint="LinkHintForField(field, linkHint)"
						:groupField="(crud === 'vds' || crud === 'certificate' || crud === 'domains') && action === 'create' && field._field_name === 'plan_id' ? findField('plan_group_id') : null"
						:backupField="crud === 'vds' && action === 'create' && field._field_name === 'template_id' ? findField('backup_id') : null"
						:accountField="crud === 'vds' && action === 'create' && field._field_name === 'template_id' ? findField('account_id') : null"
						:nameField="crud === 'domains' && action === 'create' && field._field_name === 'plan_id' ? findField('name') : null"
						:actionField="crud === 'domains' && action === 'create' && field._field_name === 'plan_id' ? findField('set_action') : null"
						:planField="crud === 'vds' && action === 'create' && field._field_name === 'backup_auto' ? findField('plan_id') : null"
						:planParams="crud === 'vds' && action === 'create' && field._field_name === 'backup_auto' ? params : null"

						:diskQuantity="crud === 'disks' && action === 'create' && field._field_name === 'backup_auto' ? findField('quantity') : null"

						:bigButton="showPayButton && field._field_name === 'fake_1_1'"
						:bigButtonTitle="showPayButton && field._field_name === 'fake_1_1' ? 'operation/pay' : null"
						:bigButtonHandler="showPayButton && field._field_name === 'fake_1_1' ? onClientCreateOperation : null"
						:bigButtonEnabled="showPayButton && field._field_name === 'fake_1_1' && isSubmitButtonEnabled"

						:linkButton="showPayButton && field._field_name === 'fake_1_2'"
						:linkButtonTitle="showPayButton && field._field_name === 'fake_1_2' ? 'paymentauto/update_title' : null"
						:linkButtonUrl="'/paymentauto/create'"
						:linkButtonVisible="showAutoPaymentButton"

						:formFields="crud === 'vds' && action === 'create' ? formData.fields : null"

						:progress="crud === 'iso' && action === 'create' && (field._field_name === 'download' || field._field_name === 'library') ? isoFormFileProgress : null"

						:diskTypeValue="crud === 'disks' && field._field_name === 'quantity' ? outerDiskTypeValue : null"

						v-model="field.value"
						@valueChanged="fieldChanged(field)"
						@abortUpload="fieldChanged(field)"
						@uploadFinished="onUploadFinished"
						@blur="onBlur(field)"
						@focus="onFocus(field)"
						@blockFormButton="blockFormButton"
						@unblockFormButton="unblockFormButton"
						@cropCoords="cropCoords"
						@enterKeyDown="onEnterKeyDown"
						@deleteFileValue="deleteFileValue"
						@operationNextStep="onClientCreateOperation"
						@answerTemplateDialog="showTemplateDialog"
						@event_Input="onTextEvent"
						@groupChanged="onGroupChanged"
						@domainName="onDomainName"
						@templateTab="onTemplateTab"
						@createBackup="createBackup"
						@deleteSavedPayment="onDeleteSavedPayment"
						@freePort="onFreePort"
						@value2FA="on2FAValue"
						@isoUploadError="onIsoUploadError"
						@isoUploadCanceled="onIsoUploadCanceled"
						@isoUploadFinished="onIsoUploadFinished"
						@outerDiskTypeChanged="onOuterDiskTypeChanged"
						@autoprolongWarning="onAutoprolongWarning"
						@params="onParams" />
				</div>

				<!-- галочка сброса настроек -->
				<div v-if="crud === 'options'" class="w5-form-row">
					<div class="w5-field">
						<input type="checkbox" class="w5-checkbox-field" name="clearSettings" v-model="clearSettings" style="display: none" />
						<label @click.stop.self="clearSettings = !clearSettings" style="display: inline-flex; height: 3em; line-height: 1;">
							{{ 'main/clear_settings' | ftc }}
						</label>
						&nbsp;
						<notice :text="'main/clear_settingst_notice' | ftc" :index="clearSettings" />
					</div>
				</div>

				<!-- номер мелодии для тикетницы -->
				<div v-if="crud === 'options'" class="w5-form-row">
					<div class="w5-field">
						<span style="display: inline-block; font-weight: 400; margin-right: 10px">
							{{ 'notifier/choose_track' | ftc }}
						</span>
						<br class="visible-xs">
						<span class="notifier-track-wrapper">
							<span class="notifier-track switcher">
								<font-awesome-icon
									:icon="whatVolume ? 'volume-up' : 'volume-mute'"
									fixed-width
									@click.stop="setVolume"
								/>
							</span>

							<span class="notifier-track" :class="trackNo === 0 ? 'selected' : false" @click.stop="setTrack(0)">1</span>
							<span class="notifier-track" :class="trackNo === 1 ? 'selected' : false" @click.stop="setTrack(1)">2</span>
							<span class="notifier-track" :class="trackNo === 2 ? 'selected' : false" @click.stop="setTrack(2)">3</span>
							<span class="notifier-track" :class="trackNo === 3 ? 'selected' : false" @click.stop="setTrack(3)">4</span>
							<span class="notifier-track" :class="trackNo === 4 ? 'selected' : false" @click.stop="setTrack(4)">5</span>
							<span class="notifier-track" :class="trackNo === 5 ? 'selected' : false" @click.stop="setTrack(5)">6</span>
						</span>
					</div>
				</div>

				<!-- подсказка-ссылка для создания VDS -->
				<div v-if="crud === 'vds' && action === 'create' && formData && formData.fields && linkHint && !linkHintShowIf && activeCreateVdsTemplateTab !== 'backup'" class="w5-info-link vds-create">
					<font-awesome-icon icon="info-circle" class="margin-right-6" />
					<span v-if="linkHint.afterText" class="font-weight-500"> {{ linkHint.afterText | ftc }}</span>
					<span v-else-if="linkHint && linkHint.length && linkHint[0].afterText" class="font-weight-500"> {{ linkHint[0].afterText | ftc }}</span>
				</div>

				<!-- кнопка -->
				<div v-if="crud !== 'operation' || action !== 'create' || $store.state.user_type !== 'client'"
					ref="button_wrapper"
					class="w5-field form-button"
					:class="{ 'margin-top-30': isFormWithDivider }">
					<button
						type="button"
						ref="submit_button"
						@click="submitForm"
						:disabled="buttonBlock > 0 && !outerDiskRequestType ? 'disabled' : false"
						class="btn btn-submit btn-primary w5-button-save"
						:class="{ hidden: form_Loading && !outerDiskRequestType, fxd: isFormButtonFixed }">
						{{ action === 'update' || action === 'alerts' || action === 'links' ? 'main/save' : 'main/create' | ftc }}
					</button>
				</div>

			</fieldset></form>

			<!-- подсказка-ссылка -->
			<div v-if="formData && formData.fields && linkHint && linkHint.position === 'bottom'" class="w5-info-link margin-right-10 margin-top-20">
				<template v-if="linkHintShowIf">
					<font-awesome-icon icon="link" />
					<a :href="linkHint.link" target="_blank">{{ linkHint.title | ftc }}</a>
				</template>
				<font-awesome-icon v-else icon="info-circle" class="margin-right-6" />
				<span v-if="linkHint.afterText" class="font-weight-500"> {{ linkHint.afterText | ftc }}</span>
			</div>

			<!-- блок с локальным сообщением об успехе -->
			<transition name="fallingBlock" key="transitionSuccess">
				<div v-show="localSuccessMessage !== ''" class="alert alert-success font-size-90 falling-block" role="alert" style="margin-right: 10px; word-break: break-word;">
					<button @click="localSuccessMessage = ''" class="close" :title="'main/close' | ftc">×</button>
					{{ localSuccessMessage | ftc }}
				</div>
			</transition>



			<!-- диалог пополнения баланса -->
			<transition name="modal">
				<div v-show="showMoneyModal" @click="hideMoneyModal" class="modal-mask">
					<div class="modal-wrapper">
						<div class="modal-container" @click.stop>

							<!-- заголовок -->
							<div class="modal-header">
								<span class="font-weight-500">{{ moneyModalTitle | ftc }}</span>
								<button type="button" class="close" @click="hideMoneyModal">&times;</button>
							</div>

							<!-- тело диалога -->
							<div class="modal-body">
							<div class="alert alert-danger font-size-90 margin-0">
								<p class="padding-0-5" v-withSafeTags="moneyModalText"></p>
							</div>
							</div>

							<!-- подвал -->
							<div class="modal-footer">
								<span v-if="moneyModalAddButton !== ''" class="btn btn-submit" @click="continueSubmit">{{ moneyModalAddButton | ftc }}</span>
								<span class="btn btn-submit" @click="goToMoney">{{ 'operation/replenishment' | ftc }}</span>
							</div>
						</div>
					</div>
				</div>
			</transition>



			<!-- диалог выбора шаблона ответа для тикета -->
			<transition name="modal">
				<div v-show="showTemplateModal" @click="hideTemplateModal" class="modal-mask">
					<div class="modal-wrapper">
						<div class="modal-container" @click="filterModalContainers">

							<!-- заголовок -->
							<div class="modal-header">
								<span class="font-weight-500">{{ 'text/find_templates' | ftc }}</span>
								<button type="button" class="close" @click="hideTemplateModal">&times;</button>
							</div>

							<!-- тело диалога -->
							<div class="modal-body">
								<textSearch ref="textSearchTemplateDialog" :Field="templateField" @textSelected="templateChoiced" />
							</div>
							
						</div>
					</div>
				</div>
			</transition>


			<!-- диалог создания ключа -->
			<transition name="modal">
				<div v-show="showSshKeyModal" @click="hideSshKeyModal" class="modal-mask">
					<div class="modal-wrapper">
						<div class="modal-container wide" @click.stop>

							<!-- заголовок -->
							<div class="modal-header">
								<span class="font-weight-500">{{ 'sshkey/create_title' | ftc }}</span>
								<button type="button" class="close" @click="hideSshKeyModal">&times;</button>
							</div>

							<!-- тело диалога -->
							<div v-if="sshKeyFields && sshKeyFields.fields" class="modal-body">
								<div v-for="(row, index) in sshKeyFields.fields" v-if="row" :key="index" :class="{ 'w5-form-row': isVisibleSshKeyField(row) }">
									<Field v-for="field in row"
										:key="field._field_name"
										:isVisibleRow="isVisibleSshKeyField(row)"
										:fieldInModal="true"
										:removeRightPadding="true"
										crud="sshkey"
										action="create"
										:Field="field"
										v-model="field.value"
										@blur="onBlurSshKey(field)"
										@focus="onFocusSshKey(field)"
										@enterKeyDown="onEnterKeyDownSshKey" />
								</div>
							</div>

							<!-- подвал -->
							<div class="modal-footer">
								<span class="btn btn-submit pull-right" @click="sshKeyCreateBegin">{{ 'sshkey/create_button' | ftc }}</span>
							</div>
						</div>
					</div>
				</div>
			</transition>



			<!-- диалог создание плательщика -->
			<transition name="modal">
				<div v-show="showPayerDialogModal" @click="hidePayerDialogModal" class="modal-mask">
					<div class="modal-wrapper">
						<div class="modal-container" @click.stop>

							<!-- заголовок -->
							<div class="modal-header">
								<span class="font-weight-500">{{ 'payer/payer' | ftc }}</span>
								<button type="button" class="close" @click="hidePayerDialogModal">&times;</button>
							</div>

							<!-- тело диалога -->
							<div class="modal-body">
							<div class="alert alert-warning margin-0">
								<p class="padding-0-5" v-withSafeTags="localeFtc('payer/new_alert')"></p>
							</div>
							</div>

							<!-- подвал -->
							<div class="modal-footer">
								<span class="btn btn-submit" @click="goToCreatePayer">{{ 'payer/create_title' | ftc }}</span>
							</div>
						</div>
					</div>
				</div>
			</transition>



			<!-- диалог удаления записи -->
			<transition name="modal">
				<div v-show="showDeleteModal" @click="hideDeleteModal" class="modal-mask">
					<div class="modal-wrapper">
						<div class="modal-container" @click.stop>

							<!-- заголовок -->
							<div class="modal-header">
								<span class="font-weight-500">{{ 'main/deleting' | ftc }}</span>
								<button type="button" class="close" @click="hideDeleteModal">&times;</button>
							</div>

							<!-- тело диалога -->
							<div class="modal-body"><p class="padding-0-5" v-withSafeTags="deleteModalText"></p></div>

							<!-- подвал -->
							<div class="modal-footer">
								<span class="btn btn-submit btn-submit-danger pull-right" :disabled="deleteModalTimer && deleteModalTimer > 0 ? 'disabled' : false" @click="deleteModalCallback">{{ deleteButtonTitle }}</span>
							</div>
						</div>
					</div>
				</div>
			</transition>


			<!-- общий диалог -->
			<transition name="modal">
				<div v-show="showGeneralDialog" @click="hideGeneralDialog" class="modal-mask">
					<div class="modal-wrapper">
						<div class="modal-container" @click.stop>

							<!-- заголовок -->
							<div class="modal-header">
								<span class="font-weight-500">{{ generalDialogTitle | ftc }}</span>
								<button type="button" class="close" @click="hideGeneralDialog">&times;</button>
							</div>

							<!-- тело диалога -->
							<div class="modal-body"><p class="padding-0-5" v-withSafeTags="generalDialogText"></p></div>

							<!-- подвал -->
							<div class="modal-footer">
								<span class="btn btn-submit pull-right" :class="{ 'btn-submit-danger': generalDialogButtonStyle === 1 }" :disabled="generalDialogTimer && generalDialogTimer > 0 ? 'disabled' : false" @click="generalDialogCallback">{{ generalDialogButtonTitle }}</span>
							</div>
						</div>
					</div>
				</div>
			</transition>



			<!-- диалог 2FA -->
			<transition name="modal">
				<div v-show="show2FADialogModal" @click="hide2FADialogModal" class="modal-mask">
					<div class="modal-wrapper">
						<div class="modal-container" @click.stop>

							<!-- заголовок -->
							<div class="modal-header">
								<span class="font-weight-500">{{ fields2FA && fields2FA.__value ? 'twofa/delete_title' : 'twofa/create_title' | ftc }}</span>
								<button type="button" class="close" @click="hide2FADialogModal">&times;</button>
							</div>

							<!-- тело диалога -->
							<div v-if="fields2FA && fields2FA.fields" class="modal-body">
								<div v-for="(row, index) in fields2FA.fields" v-if="row" :key="index" :class="{ 'w5-form-row v-center': isVisibleField(row) }">
									<template v-for="field in row">
										<Field v-if="field.type !== 'image'"
											:key="field._field_name"
											:isVisibleRow="isVisibleField(row)"
											:fieldInModal="true"
											:removeRightPadding="true"
											crud="twofa"
											action="create"
											:Field="field"
											v-model="field.value"
											@blur="onBlurSshKey(field)"
											@focus="onFocusSshKey(field)"
											@enterKeyDown="submit2FAForm" />
										<img v-else :src="field.value" :title="field.title" class="qr">
									</template>
								</div>
							</div>

							<!-- подвал -->
							<div class="modal-footer">
								<!-- ссылки на приложения -->
								<div v-if="!fields2FA || !fields2FA.__value" class="hidden-xs pull-left">
									<a class="app-link google-play" href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2" target="_blank" rel="nofollow noopener">Google Play</a>
									<a class="app-link app-store" href="https://apps.apple.com/ru/app/google-authenticator/id388497605" target="_blank" rel="nofollow noopener">App Store</a>
								</div>
								<span class="btn btn-submit" @click="submit2FAForm">{{ 'twofa/check' | ftc }}</span>
							</div>
						</div>
					</div>
				</div>
			</transition>

			<audio src="/static/snd/notif.mp3" ref="audioNotif_00" />
			<audio src="/static/snd/notif01.mp3" ref="audioNotif_01" />
			<audio src="/static/snd/notif02.mp3" ref="audioNotif_02" />
			<audio src="/static/snd/notif03.mp3" ref="audioNotif_03" />
			<audio src="/static/snd/notif04.mp3" ref="audioNotif_04" />
			<audio src="/static/snd/notif05.mp3" ref="audioNotif_05" />

		</template>

		<errorAlert v-else :message="form_ErrorMessage"></errorAlert>

	</div>
	
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import Vue from 'vue'
import Field from '@/components/elements/formfield'
import OuterDiskType from '@/components/elements/outerdisktype'
import Helper from '@/helper/helper'
import validatorArrayField from '@/validators/array'
import { EventBus } from '@/bus.js'
import textSearch from '@/components/elements/text'
import notice from '@/components/elements/notice'
import mixinCachedRequests from '@/mixins/cached-request'
import $ from 'jquery'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'Update',
	//=========================================================================
	// mixin'ы
	//=========================================================================
	mixins: [mixinCachedRequests],
	//=========================================================================
	// изменяемые локальные свойства
	//=========================================================================
	data() {
		return {
			// наименование CRUD-объекта (например: 'bonus')
			crud: null,

			// действие: create | update | clone
			action: null,

			// ID редактируемого объекта
			id: null,

			// локальное сообщение об ошибке
			localErrorMessage: '',
			// лоакльное сообщение об успехе
			localSuccessMessage: '',
			localSuccessMessageTimer: null,

			// данные формы
			formData: {
				title: ' '
			},

			// информация о форме
			formInfo: null,

			// блокиовка кнопки формы
			buttonBlock: 0,

			// требуется ли рефреш мини-аватара пользователя
			refreshMiniAvatar: false,

			// признак сабмита формы
			isFormSubmited: false,

			// диалог пополнения баланса
			showMoneyModal: false,
			moneyModalTitle: '',
			moneyModalText: '',
			moneyModalAddButton: '',

			// диалог выбора шаблона ответа для тикета
			showTemplateModal: false,
			templateField: {
				required: true,
				type: 'list',
				list: [],
				title: 'mails/templates',
				_field_name: 'ticketTemplateModalValue',
				_is_short: true,
				_visible: true,
				_errMsg: '',
				url: '/text/list?search=template&category=notice&q='
			},

			// диалог создания ssh-ключа для клиентов
			showSshKeyModal: false,
			sshKeyFields: null,

			// диалог создания плательщика
			showPayerDialogModal: false,

			// кнопка сброса настроек
			clearSettings: false,

			// данные в виде FormData
			FD: false,
			FD_count: 0,

			// таймер для отлова нажатий клавиш для списков
			listKeyDownTimer: null,

			// номер мелодии для тикетницы, используется только в профиле
			trackNo: 0,
			// ссылка на элемент "audio"
			audio: null,
			canPlay: false,

			// ссылка на значение опции - по умолчанию звук включен
			whatVolume: true,

			// кеш для дата-центров при изменении группы/тарифами
			dataCenterRequestCache: {},

			// хендлеры запросов проверяющих поле
			verifyRequestsHandlers: [],

			// вкладка у шаблонов при создании VDS
			activeCreateVdsTemplateTab: '',
			createVdsTemplateTabCache: {
				tab: null,
				account_id: null,
				datacenter_id: null
			},

			// диалог удаления
			showDeleteModal: false,
			deleteModalValue: null,
			deleteModalText: '',
			deleteButtonTitle: '',
			deleteModalTimer: null,
			deleteModalTimerHandler: null,

			// 2FA диалог
			show2FADialogModal: false,
			fields2FA: null,

			// ISO form timer
			isoFormTimer: null,
			isoFormFileHost: '',
			isoFormFileToken: null,
			isoFormFileProgress: '',

			// параметры
			params: null,

			// изменился ли тариф-конструктор
			isConstructPlanChanged: false,

			// поле выбора типа внешнего диска
			outerDiskTypeValue: 17,
			outerDiskSavedFields: null,
			outerDiskRequestType: false,
			outerDiskFormsCache: {},

			// общий диалог
			showGeneralDialog: false,
			generalDialogTitle: '',
			generalDialogText: '',
			generalDialogButtonStyle: 0,
			generalDialogCallback: () => {},
			generalDialogButtonTitle: '',
			generalDialogTimer: 0,
			generalDialogTimerHandler: null,

			// обсервер
			intersectionObserver: null,
			isFormButtonFixed: false
		}
	},
	//=========================================================================
	//  вычисляемые неизменяемые переменные
	//=========================================================================
	computed: {
		// конфигурация
		Config() {
			if (this.$store.state.user_type === 'client') return this.$store.state.clientConfig
			else if (this.$store.state.user_type === 'admin') return this.$store.state.adminConfig
			else return false
		},
		// ссылки-подсказки
		linkHint() {
			if (this.crud && this.action &&
				this.Config &&
				this.Config[this.crud] &&
				this.Config[this.crud]['hint-link'] &&
				this.Config[this.crud]['hint-link'][this.action])
				return this.Config[this.crud]['hint-link'][this.action]

			return false
		},
		// видимость ссылки-подсказки привязанная к полю
		linkHintShowIf() {
			// если нет подсказки вообще - не показываем
			if (!this.linkHint) return false

			// если есть привязка к полю
			if (typeof this.linkHint === 'object' && !Array.isArray(this.linkHint))
			{
				if (this.linkHint.showIfField)
				{
					// найдем это поле
					let _field = this.findField(this.linkHint.showIfField)
					if (!_field) return false
					// вернем его видимость
					return _field['_visible']
				}
			}
			else if (typeof this.linkHint === 'object' && Array.isArray(this.linkHint))
			{
				let _result = false
				this.linkHint.some(item => {
					if (item.showIfField)
					{
						// найдем это поле
						let _field = this.findField(item.showIfField)
						if (_field)
						{
							// вернем его видимость
							_result = _field['_visible']
							return true
						}
					}
				})

				return _result
			}

			// по умолчанию - показываем
			return true
		},
		// видимость дополнительной информации
		showAdditionalInfo() {
			// показываем только клиентам
			if (this.$store.state.user_type !== 'client') return false
			// если нет данных вообще
			if (!this.formInfo || typeof this.formInfo !== 'object' || !Object.keys(this.formInfo).length) return false
			// если это массив - это не то
			if (Array.isArray(this.formInfo)) return false
			// если нет ни максимального значения, ни стоимости вообще
			if (!('max' in this.formInfo) && !('cost' in this.formInfo.max)) return false
			// если максимальное значение больше бесконечности
			if (this.formInfo.max >= 100000) return false

			// в остальных случаях показываем
			return true
		},
		// кнопка оплатить в форме оплаты для клиентов
		showPayButton() {
			return this.$store.state.user_type !== 'admin' &&
				this.crud === 'operation' &&
				this.action === 'create'
		},
		// кнопка редиректа в создание автоплатежа
		showAutoPaymentButton() {
			if (!this.showPayButton) return false

			let _savedField = this.findField('saved')
			if (_savedField && _savedField.list && _savedField.list.length)
			{
				return true
			}

			return false
		},
		// кнопка оплаты клиентом
		isSubmitButtonEnabled() {
			// если это не создание платежа
			if (this.crud !== 'operation' || this.action !== 'create') return true
			// если это сотрудник
			if (this.$store.state.user_type === 'admin') return true

			let _savedField = this.findField('saved')
			let _paymentField = this.findField('payment')

			if (_savedField && _savedField.value) return true
			if (_paymentField && _paymentField.value) return true

			return false
		},
		// лочит всю форму
		isFormLocked() {
			// частные случаи
			if (this.crud === 'paymentauto')
			{
				let _savedField = this.findField('saved_id')

				if (this.$store.state.user_type === 'client')
				{
					if (_savedField &&
						(!_savedField.list || !_savedField.list.length))
					{
						return true
					}
				}
			}

			return false
		},
		// есть ли в форме поля с типом "header"
		isFormWithDivider() {
			// если нет вообще полей
			if (!this.formData.fields) return false

			// поля есть - пробежимся по ним
			let _found = false
			this.formData.fields.some(item => {
				if (item && Array.isArray(item))
				{
					item.some(obj => {
						if (obj && obj.type === 'header' && obj._visible)
						{
							_found = true
							return true
						}
					})

					if (_found) return true
				}
			})

			return _found
		},
		// есть ли в форме поля с типом "header" и заданым "number"
		isFormWithNumberDivider() {
			// если нет вообще полей
			if (!this.formData.fields) return false

			// поля есть - пробежимся по ним
			let _found = false
			this.formData.fields.some(item => {
				if (item && Array.isArray(item))
				{
					item.some(obj => {
						if (obj && obj.type === 'header' && obj._visible && obj.number)
						{
							_found = true
							return true
						}
					})

					if (_found) return true
				}
			})

			return _found
		}
	},
	//=========================================================================
	// функция, которыя будет вызвана после создания компонента,
	// но перед монтированием в дом
	//=========================================================================
	created() {
		// обнуляем флаг измененной формы
		this.$store.commit('changedForm', false)

		// если не авторизован - редирект на страницу логина
		if (!this.$store.state.is_auth)
		{
			// сброс аутентификации
			this.$store.commit('dropAuth')
			// запоминаем URL, что бы к нему вернуться
			this.$store.commit('setReturnURL', this.$route.path)
			// остановим Push-систему
			this.$store.commit('pushStop')
			// делаем редирект
			return this.$router.push('/login')
		}

		// инициализация начальных данных по URL
		this.initData(this.$route.path)

		if (this.crud === 'ticket')
		{
			// дополняем jquery функцией
			$.fn.setCursorPosition = function(pos) {
				this.each(function(index, elem) {
					if (elem.setSelectionRange)
					{
						elem.setSelectionRange(pos, pos)
					}
					else if (elem.createTextRange)
					{
						var range = elem.createTextRange()
						range.collapse(true)
						range.moveEnd('character', pos)
						range.moveStart('character', pos)
						range.select()
					}
				})

				return this
			}
		}

		// сначала идут подготовительные запросы
		this.firstTimeRequestData()
		// теперь можно запросить данные
		.then(() => {
			if (this.crud) this.requestData()
		})
	},
	//=========================================================================
	// после того как компонент смонтирован
	//=========================================================================
	mounted() {
		// чистим кеш
		this.dataCenterRequestCache = {}

		// навешиваем обработчик на нажатие клавиш
		document.addEventListener('keydown', this.keyDownHandler)
		// подписка на Push-сообщения
		EventBus.$on('w5-push', this.pushMessageHandler)
		// подписка на событие - блокировка сообщения
		EventBus.$on('w5-block-application', this.blockApplicationHandler)
		// закрытие вкладки или рефреш
		window.onbeforeunload = this.onBeforeUnload
		// изменение опций пользователя на сервере
		EventBus.$on('w5-user-options-on-server', this.optionHandler)
		// переход на создение персоны
		EventBus.$on('w5-goto-url', this.gotoUrl)
		// создание платежки юр.лицом
		EventBus.$on('w5-payment-bank-legal', this.bankLegalPaySubmit)
		// показ диалога создания плательщика
		EventBus.$on('w5-show-payer-dialog', this.showPayerDialog)
		// storage
		window.addEventListener('storage', this.onLocalStorageEvent)
		// есть ли изменения в конструкторе
		EventBus.$on('w5-plan-constructor-changed', this.handlePlanConstructorChanged)
		// если перегрузилось поле
		EventBus.$on('w5-vds-create-field-reloaded', this.handleCreateFieldReloaded)

		if (this.crud === 'options')
		{
			// первоначальное значение
			this.whatVolume = Helper.normalizeBooleanValue(this.$store.state.userServerOptions.play_audio_on_notification)
			// если значения нет - это true
			if (!('play_audio_on_notification' in this.$store.state.userServerOptions))
				this.whatVolume = true

			// получим элемент "audio"
			let _name = 'audioNotif_'
			if (['00', '01', '02', '03', '04', '05'].indexOf(this.$store.state.userServerOptions.audio_track_on_notification) > -1)
			{
				this.trackNo = parseInt(this.$store.state.userServerOptions.audio_track_on_notification, 10)
				_name += this.$store.state.userServerOptions.audio_track_on_notification
			}
			else
			{
				this.trackNo = 0
				_name += '00'
			}

			this.audio = this.$refs[_name]
			if (this.audio) this.audio.addEventListener('canplay', this.audioCanPlay)
		}

		// обсервер - следит за кнопкой
		if (this.$refs['button_wrapper'])
		{
			this.intersectionObserver = new IntersectionObserver(this.handleObserver, { threshold: 0 })
			this.intersectionObserver.observe(this.$refs['button_wrapper'])
		}
	},
	//=========================================================================
	// после того как компонент обновился
	//=========================================================================
	updated() {
		this.$nextTick(() => {
			// если есть глобальная ошибка
			// ошибки в полях проверяются при сабмите формы
			if (this.localErrorMessage || this.form_ErrorMessage)
			{
				$('body, html').animate({ scrollTop: 0 }, 500)
			}
		})
	},
	//=========================================================================
	// перед уничтожением компонента
	//=========================================================================
	beforeDestroy() {
		// чистим кеш
		this.dataCenterRequestCache = {}

		// убираем обработчики событий
		document.removeEventListener('keydown', this.keyDownHandler)
		window.onbeforeunload = null
		window.removeEventListener('storage', this.onLocalStorageEvent)
		// отписка от Push-сообщений
		EventBus.$off('w5-push', this.pushMessageHandler)
		// отписка
		EventBus.$off('w5-block-application', this.blockApplicationHandler)
		EventBus.$off('w5-user-options-on-server', this.optionHandler)
		EventBus.$off('w5-goto-url', this.gotoUrl)
		EventBus.$off('w5-payment-bank-legal', this.bankLegalPaySubmit)
		EventBus.$off('w5-show-payer-dialog', this.showPayerDialog)
		EventBus.$off('w5-plan-constructor-changed', this.handlePlanConstructorChanged)
		EventBus.$off('w5-vds-create-field-reloaded', this.handleCreateFieldReloaded)

		// все для мелодии нотификатора
		if (this.audio) this.audio.removeEventListener('canplay', this.audioCanPlay)

		// если запущены таймеры
		// ISO
		if (this.isoFormTimer)
		{
			clearInterval(this.isoFormTimer)
			this.isoFormTimer = null
		}
		// general dialog
		if (this.generalDialogTimerHandler) {
			clearInterval(this.generalDialogTimerHandler)
			this.generalDialogTimerHandler = null
		}
		// delete
		if (this.deleteModalTimerHandler) {
			clearInterval(this.deleteModalTimerHandler)
			this.deleteModalTimerHandler = null
		}

		// если есть обсервер
		if (this.intersectionObserver && this.$refs['button_wrapper'])
		{
			this.intersectionObserver.unobserve(this.$refs['button_wrapper'])
		}
	},
	//=========================================================================
	// обработчик: перед переходом по URL
	//=========================================================================
	beforeRouteLeave(to, from, next) {
		next(this.onBeforePopState())
	},
	//=========================================================================
	// локальные методы формы
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// самый первый запрос данных
		//---------------------------------------------------------------------
		firstTimeRequestData() {
			return new Promise(async resolve => {
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// если это создание VDS - запросим группы шаблонов
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				if (this.crud === 'vds' && this.action === 'create')
				{
					// если еще нет данных
					if (!this.$store.state.isLastTemplateGroupCacheLoaded)
					{
						await this.$store.dispatch('getTemplateGroupCache')
					}
				}

				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// разрешаем промис
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				resolve()
			})
		},
		//---------------------------------------------------------------------
		// возвращает подсказки для заданого поля
		//---------------------------------------------------------------------
		LinkHintForField(field, links) {
			if (!field || !links) return null
			if (typeof links === 'object' && !Array.isArray(links))
			{
				if (links.showIfField === field._field_name) return links
			}
			else if (typeof links === 'object' && Array.isArray(links))
			{
				let _result = null
				links.some(item => {
					if (item.showIfField === field._field_name)
					{
						_result = item
						return true
					}
				})

				return _result
			}

			return null
		},
		//---------------------------------------------------------------------
		// событие: нажата клавиша на всем документе
		//---------------------------------------------------------------------
		keyDownHandler(e) {
			// закрытие всех диалогов по ESC
			if (e.keyCode === 27)
			{
				this.hideMoneyModal()
				this.hideTemplateModal()
				this.hideSshKeyModal()
				this.hidePayerDialogModal()
				this.hideDeleteModal()
				this.hide2FADialogModal()
				this.hideGeneralDialog()
			}
		},
		//---------------------------------------------------------------------
		// есть ли поле с ошибками - передвигается к нему
		//---------------------------------------------------------------------
		MoveToFieldWithError() {
			this.$nextTick(() => {
				if (!this.formData || !this.formData.fields) return

				let _isError = false
				this.formData.fields.some(item => {
					if (item && Array.isArray(item))
					{
						item.some(obj => {
							if (obj && obj['_errMsg'])
							{
								_isError = obj['_field_name']
								return true
							}
						})

						if (_isError) return true
					}
				})

				if (_isError)
				{
					// это ошибка у поля - нужно найти его
					let _ref = this.$refs[_isError]
					if (_ref && _ref[0] && _ref[0].$el)
					{
						let _$el = $(_ref[0].$el)
						if (_$el.length)
							$('html, body').animate({ scrollTop: _$el.offset().top - 45 }, 400)
					}
				}
			})
		},
		//---------------------------------------------------------------------
		// подтверждение формы
		//---------------------------------------------------------------------
		submitForm(e) {
			// форма загрузки ISO - если еще небыло предварительного запроса
			if (this.crud === 'iso' && this.action === 'create' && e !== 'submit-iso-form')
			{
				// делаем сначала предварительный запрос
				this.submitIsoForm()
				return
			}

			// чистим сообщения
			this.localErrorMessage = ''
			this.localSuccessMessage = ''

			// обнуляем флаг в этом месте в любом случае
			this.outerDiskRequestType = false

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// бежим по всем полям
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			let _rows = this.formData['fields']
			// если полей нет
			if (!_rows || !Array.isArray(_rows))
			{
				this.localErrorMessage = 'error/app_internal'
				this.buttonBlock = 0
				return
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// данные для передачи
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// локальная проверка полей в виде массива
			let _arrayFieldError = validatorArrayField.validatorArray(this.form_GetData.fields, this.crud)
			// если нашли какие то ошибки
			if (_arrayFieldError)
			{
				// если получили какую то общую ошибку
				if (_arrayFieldError === true)
				{
					this.localErrorMessage = 'main/validation_error'
					this.buttonBlock = 0
					return
				}
				// получили поля с ошибками
				else
				{
					// расставим ошибки
					for (let _fieldName in _arrayFieldError)
					{
						let _fld = this.findField(_fieldName)
						if (_fld)
						{
							_fld['_errMsg'] = _arrayFieldError[_fieldName]
							EventBus.$emit('w5-set-field-error')
						}
					}
				}

				this.buttonBlock = 0
				this.MoveToFieldWithError()
				return
			}

			let _data = this.collectData(_rows)
			// если данные по каким либо причинам собрать не удалось
			if (_data === false)
			{
				this.buttonBlock = 0
				this.MoveToFieldWithError()
				return
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// частные случаи
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// 0. создание платежа клиентом
			if (this.crud === 'operation' && this.action === 'create' && this.$store.state.user_type === 'client' && this.isAccess('operation/create'))
			{
				// просто так по кнопке нельзя сабмитить форму
				if (e !== 'nextStep' && e !== 'nextStep2') return

				if (e === 'nextStep')
				{
					// найдем выбранный способ платежа
					let _paymentCase = null
					let _isSaved = false

					// проверим оплату сохраненным способом
					let _savedField = this.findField('saved')
					if (_savedField &&
						_savedField.list && _savedField.list.length &&
						'value' in _savedField &&
						_savedField['value'] !== null && _savedField['value'] !== undefined &&
						_savedField._visible === true)
					{
						// найдем данные платежа
						_savedField.list.some(f => {
							if (String(f.id) === String(_savedField.value))
							{
								_paymentCase = f
								_isSaved = true
								return true
							}
						})
					}

					// так же проверим оплату другим способом - если еще не нашли
					if (!_paymentCase)
					{
						let _paymentField = this.findField('payment')
						if (_paymentField &&
							_paymentField.list && _paymentField.list.length &&
							'value' in _paymentField &&
							_paymentField['value'] !== null && _paymentField['value'] !== undefined &&
							_paymentField._visible === true)
						{
							// найдем данные платежа
							_paymentField.list.some(f => {
								if (String(f.id) === String(_paymentField.value))
								{
									_paymentCase = f
									_isSaved = false
									return true
								}
							})
						}
					}

					// если нашли такой способ
					if (_paymentCase)
					{
						// убираем блокировку
						this.buttonBlock = 0

						// ищем сумму операции
						let _curSumma = 0
						let _smField = this.findField('summa')
						if (_smField && 'value' in _smField) _curSumma = parseFloat(_smField.value)
						if (isNaN(_curSumma) || _curSumma < 0) _curSumma = 0

						// посчитаем общую сумму к списанию
						let _com = _paymentCase['comission']
						if (_com === undefined || _com === null || isNaN(_com) || _com === '') _com = 0
						_com = parseFloat(_com)
						let _price = (_curSumma + _com * _curSumma / 100.0).toFixed(2)
						_price = parseFloat(_price)

						// формируем текст
						let _text = this.localeFtc('operation/payment_info')
							.replace('{saved}', _isSaved ? this.localeFtc(' (payment/saved_title)') : '')
							.replace('{name}', _paymentCase['name'] ? this.localeFtc(_paymentCase['name']) : this.localeFtc('payment/usual_title'))
							.replace('{com}', Helper.FormatMoney2(_com, 2))
							.replace('{sum}', Helper.FormatMoney2(_price, 2))
							.replace('{val}', this.localeFtc('main/ruble')) +
							'<br><br>' +
							'<w>' + this.localeFtc('operation/payment_warning') + '</w>'

						// покажем сумму
						this.generalDialogShow(
							'main/refresh_screen',
							_text,
							this.localeFtc('main/continue'),
							() => {
								this.hideGeneralDialog()
								this.submitForm('nextStep2')
							}
						)

						// дальше только через кнопку "Продолжить"
						return
					}
				}
			}
			// 1.1 создание VDS
			if (this.crud === 'vds' && this.action === 'create')
			{
				// обязательно должно быть задано одно из полей: template_id, backup_id или iso_id
				let tempField = this.findField('template_id')
				let backField = this.findField('backup_id')
				let isoField = this.findField('iso_id')

				if (!tempField && !backField && !isoField)
				{
					this.localErrorMessage = 'template/not_selected'
					this.buttonBlock = 0
					return
				}

				if (!tempField.value && !backField.value && !isoField.value)
				{
					let _errText = ''
					if (this.activeCreateVdsTemplateTab === 'backup')
					{
						_errText = 'backup/not_selected'
					}
					else if (this.activeCreateVdsTemplateTab === 'iso')
					{
						_errText = 'iso/not_selected'
					}
					else
					{
						_errText = 'template/not_selected'
					}

					if (tempField)
						tempField._errMsg = _errText
					else
						this.localErrorMessage = _errText

					this.buttonBlock = 0
					this.MoveToFieldWithError()
					return
				}
			}
			// 1. создание VDS/сертификата клиентом
			if ((this.crud === 'vds' || this.crud === 'certificate') && this.$store.state.user_type === 'client' && this.moneyModalAddButton !== 'continue')
			{
				// получим ID выделенного тарифного плана
				let _fieldPlan = this.findField('plan_id')
				if (!_fieldPlan || !('value' in _fieldPlan) || !_fieldPlan['list'] || !Array.isArray(_fieldPlan['list']))
				{
					this.localErrorMessage = 'plan/not_found'
					this.buttonBlock = 0
					return
				}

				// получим сам тарифный план
				let _plan = false
				_fieldPlan['list'].some(item => {
					if (String(item['id']) === String(_fieldPlan['value']))
					{
						_plan = item
						return true
					}
				})

				if (!_plan)
				{
					this.localErrorMessage = 'plan/not_found'
					this.buttonBlock = 0
					return
				}

				// получим текущий баланс - он всегда тут будет актуальным из-за PUSH-системы
				if (!this.$store.state.user_balance ||
					this.$store.state.user_balance.real === undefined ||
					this.$store.state.user_balance.real === null)
				{
					this.localErrorMessage = this.localeFtc('operation/purse_real: error/unknown')
					this.buttonBlock = 0
					return
				}

				let _cost = parseFloat(_plan['cost'])
				let _minMoney = parseFloat(_plan['min_money'])
				let _canBonus = Helper.normalizeBooleanValue(_plan['can_bonus'])
				let _period = _plan['period_name'] ? this.localeFtc(_plan['period_name']) : this.localeFtc(_plan['period'])
				let _realBalance = parseFloat(this.$store.state.user_balance.real)
				let _bonusBalance = parseFloat(this.$store.state.user_balance.bonus)
				let _text = ''
				let _newSum = 0.0
				this.moneyModalAddButton = ''

				// если выбран тариф-конструктор, пересчитаем всю сумму
				if (_plan.has_params && _plan.params && _plan.data)
				{
					// cpu
					if (_plan.data.cpu && _plan.data.cpu.value)
					{
						let _v = parseFloat(_plan.data.cpu.value) - parseFloat(_plan.params && _plan.params.cpu && _plan.params.cpu.min ? _plan.params.cpu.min : 0)
						let _c = _plan.params && _plan.params.cpu && (_plan.params.cpu.cost || _plan.params.cpu.full_cost)
							? Math.min(parseFloat(_plan.params.cpu.cost), parseFloat(_plan.params.cpu.full_cost))
							: 0
						_cost += (_v * _c)
					}

					// ram
					if (_plan.data.ram && _plan.data.ram.value)
					{
						let _v = parseFloat(_plan.data.ram.value) - parseFloat(_plan.params && _plan.params.ram && _plan.params.ram.min ? _plan.params.ram.min : 0)
						let _c = _plan.params && _plan.params.ram && (_plan.params.ram.cost || _plan.params.ram.full_cost)
							? Math.min(parseFloat(_plan.params.ram.cost), parseFloat(_plan.params.ram.full_cost))
							: 0
						_cost += (_v * _c)
					}

					// disk
					if (_plan.data.disk && _plan.data.disk.value)
					{
						let _v = parseFloat(_plan.data.disk.value) - parseFloat(_plan.params && _plan.params.disk && _plan.params.disk.min ? _plan.params.disk.min : 0)
						let _c = _plan.params && _plan.params.disk && (_plan.params.disk.cost || _plan.params.disk.full_cost)
							? Math.min(parseFloat(_plan.params.disk.cost), parseFloat(_plan.params.disk.full_cost))
							: 0
						_cost += (_v * _c)
					}

					// ip4
					if (this.params && this.params['params[ip4]'])
					{
						let _c = _plan.params && _plan.params.ip4 && (_plan.params.ip4.cost || _plan.params.ip4.full_cost)
							? Math.min(parseFloat(_plan.params.ip4.cost), parseFloat(_plan.params.ip4.full_cost))
							: 0
						_cost += _c
					}

					// и только теперь округляем всю стоимость
					_cost = parseFloat(_cost.toFixed(2))
				}

				// заголовок диалога
				this.moneyModalTitle = 'service/create_title'
				if (this.crud === 'vds') this.moneyModalTitle = 'service/creating_vds'

				// если не хватает денег на заказ услуги
				if (_realBalance < _minMoney)
				{
					// если при этом минимальная сумма не задана
					if (_minMoney <= 0)
					{
						// сумма которую нужно внести
						_newSum = Math.abs(_realBalance)
						// сообщение
						_text = this.localeFtc('service/creating_min_money_0')
							.replace('{sum}', Helper.FormatMoney2(_newSum, 2))
							.replace('{val}', this.localeFtc('main/ruble'))
					}
					// минимальная сумма задана
					else
					{
						// сообщение
						_text = this.localeFtc('service/creating_min_money_1')
							.replace('{sum}', Helper.FormatMoney2(_minMoney, 2))
							.replace('{val}', this.localeFtc('main/ruble'))
						// сумма которую нужно внести
						_newSum = parseFloat((_minMoney - _realBalance).toFixed(2))
					}

					// записываем сумму для формы пополнения баланса
					const _limit = this.AppName === 'vdsina.com' ? 100 : 10000
					this.$store.commit('setOperationSumNew', _newSum > _limit ? _newSum : _limit)

					// показываем диалог пополнения счета
					this.moneyModalText = _text
					EventBus.$emit('w5-body-scroll-disable')
					this.showMoneyModal = true

					// однозначно прекращаем выполнение
					return
				}
				// баланса хватает для заказа услуги
				else
				{
					// нужно ли показывать предупреждение
					let _showModal = false

					// нужно выяснить - хватает ли денег на балансе
					// услуга закажется в любом случае, даже если не хватает денег,
					// но предупредить нужно
					if (_realBalance < _cost)
					{
						// реальных денег не хватает
						// смотрим - может можно оплатить бонусами?
						if (_canBonus)
						{
							// можно оплатить бонусами - проверим, хватает ли бонусов?
							if (_bonusBalance < _cost)
								// бонусов не хватает - нужно предупредить
								// потому что в итоге не хватает ни реальных денег, ни виртуальных
								_showModal = true
						}
						// нельзя оплачивать бонусами - нужно предупредить
						else _showModal = true
					}

					// если все таки выяснили что нужно предупредить - покажем диалог
					if (_showModal)
					{
						// формируем сообщение
						_text = this.localeFtc('service/creating_not_enough')
							.replace('{sum1}', Helper.FormatMoney2(_cost, 2))
							.replace('{val}', this.localeFtc('main/ruble'))
							.replace('{period}', _period)
							.replace('{sum2}', Helper.FormatMoney2(_realBalance, 2))
							.replace('{val}', this.localeFtc('main/ruble'))

						// сумма которую нужно внести
						_newSum = parseFloat((_cost - _realBalance).toFixed(2))
						// записываем сумму для формы пополнения баланса
						const _limit = this.AppName === 'vdsina.com' ? 100 : 10000
						this.$store.commit('setOperationSumNew', _newSum > _limit ? _newSum : _limit)

						// генерация диалога
						this.moneyModalText = _text
						// добавим кнопку продолжения
						//this.moneyModalAddButton = 'service/creating_continue'
						EventBus.$emit('w5-body-scroll-disable')
						this.showMoneyModal = true

						// однозначно прекращаем выполнение
						return
					}
				}
			}

			// 2. изменение внешнего диска
			if (this.crud === 'disks' && this.action === 'update')
			{
				// если это только сабмит главной формы
				if (e !== 'nextStep') {
					// найдем поле с размером диска
					let _quantityField = this.findField('quantity')
					// если увеличили диск
					if (_quantityField && '_oldValue' in _quantityField && 'value' in _quantityField && 'cost' in _quantityField) {
						const _old = parseFloat(_quantityField._oldValue)
						const _new = parseFloat(_quantityField.value)
						const _cost = parseFloat(_quantityField.cost)
						const _attached = Helper.normalizeBooleanValue(_quantityField.attached)

						if (!isNaN(_old) && !isNaN(_new) && !isNaN(_cost) && _old < _new) {
							let _sum = parseFloat((_new - _old).toFixed(2)) * _cost
							let _text = this.localeFtc('service/extdisk_increase_note')
									.replace('{cost}', Helper.FormatMoney2(_sum, 2))
									.replace('{val}', this.localeFtc('main/ruble'))

							if (_attached) {
								_text += '<br><br>\n\n' + this.localeFtc('service/iso_operation_warning')
							}

							this.buttonBlock = 0

							this.generalDialogShow(
								'main/refresh_screen',
								_text,
								this.localeFtc('main/continue'),
								() => {
									this.hideGeneralDialog()
									this.submitForm('nextStep')
								}
							)

							return
						}
					}
				}
			}

			// обнуляем флаг продолжения
			if (this.moneyModalAddButton === 'continue') this.moneyModalAddButton = ''

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// сразу лочим кнопку
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (this.buttonBlock <= 0) this.buttonBlock = 1

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// данные собраны - отправляем их
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// первый запрос - GET
			let _url = this.$route.path
			// частные случаи
			if (_url === '/options') _url = this.$store.state.user_type === 'admin' ? '/admin/options' : '/user/options'
			else if (_url === '/iso/create') _url = '/service/create/' + Vue.Constants.SERVICE_TYPE_ISO
			else if (_url === '/vds/create') _url = '/service/create/' + Vue.Constants.SERVICE_TYPE_VDS
			else if (_url === '/certificate/create') _url = '/service/create/' + Vue.Constants.SERVICE_TYPE_SSL
			else if (_url === '/domains/create') _url = '/service/create/' + Vue.Constants.SERVICE_TYPE_DOMAIN
			else if (_url.indexOf('/domains/update') === 0) _url = _url.replace('/domains/', '/service/')
			else if (_url === '/dns/create') _url = '/service/create/' + Vue.Constants.SERVICE_TYPE_DNS
			else if (_url.indexOf('/dns-records/') === 0) _url = _url.replace('/dns-records/', '/dns/')
			else if (_url === '/bonus/activate') _url = '/bonus/convert'
			else if (_url === '/ipptrpool/create') _url += '/' + this.id
			else if (_url === '/disks/create') _url = '/service/create/' + this.outerDiskTypeValue
			else if (_url.indexOf('/disks/update') === 0) _url = _url.replace('/disks/', '/service/')

			// переупакуем данные: NameForm[data[disk]] => NameForm[data][disk]
			_data = this.FD_rePack(_data)

			// готовим данные
			let _post = {
				'_csrf': this.form_GetData._csrf
			}
			_post[this.form_GetData.model] = _data

			// готовим данные в виде FormData
			this.FD = new FormData()
			this.FD_count = 0
			this.FD_prepare(_post)

			// это мы - если это тикетница
			if (this.crud === 'ticket') this.$store.commit('ItIsMe', true)

			// если есть запросы - проверки полей, их нужно терминировать
			if (this.verifyRequestsHandlers && this.verifyRequestsHandlers.length)
			{
				this.verifyRequestsHandlers.forEach(item => {
					if (item && item.abort)
						item.abort()
				})

				this.verifyRequestsHandlers = []
			}

			// производим сам запрос
			this.$http.post(this.APIServerUrl + _url, this.FD_count > 0 ? this.FD : null).then(
				// успешный ответ сервера
				resPost => {
					// данные
					let _dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
					// если ошибки нет
					if (_dt && _dt['status'] === 'ok')
					{
						// частные случаи
						if (this.$route.path === '/options')
						{
							// включаем кнопку обратно
							this.buttonBlock = 0
							// показываем что все ок
							this.setLocalSuccessMessage('main/save_success')
							// сбрасываем настройки
							if (this.clearSettings) this.clearSettingsStart()
							// ставим признак обновление мини-аватара
							this.refreshMiniAvatar = true
							// рефрешим данные
							this.requestData(true)
						}
						else if (this.$route.path.indexOf('/user/alerts') === 0)
						{
							// включаем кнопку обратно
							this.buttonBlock = 0
							// показываем что все ок
							this.setLocalSuccessMessage('main/save_success')
							// рефрешим данные
							this.requestData(true)
						}
						// пополнение баланса клиентом
						else if (this.crud === 'operation' && this.action === 'create' && this.$store.state.user_type === 'client' &&
							e === 'nextStep' && _dt['operation'] && _dt['operation']['operation_id'])
						{
							// ставим признак для роутера - что это сабмит формы
							this.isFormSubmited = true
							// делаем редирект на следующий шаг
							this.$router.push('/operation/pay/' + _dt['operation']['operation_id'])
						}
						// изменение сообщения тикета
						else if (this.crud === 'ticketmessage' && this.action === 'update' && this.$store.state.ticketData.ticketUpdateId)
						{
							// ставим признак для роутера - что это сабмит формы
							this.isFormSubmited = true
							// делаем редирект в просмотр тикета
							this.$router.push('/ticket/view/' + this.$store.state.ticketData.ticketUpdateId)
						}
						// настройка уведомлений
						else if (this.crud === 'user' && this.action === 'alerts')
						{
							// ставим признак для роутера - что это сабмит формы
							this.isFormSubmited = true
							// делаем редирект назад
							this.buttonBlock = 0
							this.$router.go(-1)
						}
						// создание/редактирование DNS-записи
						else if (this.crud === 'dns-records' || (this.crud === 'bonus' && this.action === 'activate'))
						{
							// ставим признак для роутера - что это сабмит формы
							this.isFormSubmited = true
							// делаем редирект назад
							this.buttonBlock = 0
							this.$router.go(-1)
						}
						// создание плательщика
						else if (this.crud === 'payer' && this.action === 'create')
						{
							// ставим признак для роутера - что это сабмит формы
							this.isFormSubmited = true
							// делаем редирект назад
							this.buttonBlock = 0
							this.$router.go(-1)
						}
						// создание ipptr
						else if (this.crud === 'ipptrpool')
						{
							// ставим признак для роутера - что это сабмит формы
							this.isFormSubmited = true
							// делаем редирект назад
							this.buttonBlock = 0
							this.$router.go(-1)
						}
						// создание disks
						else if (this.crud === 'disks')
						{
							// ставим признак для роутера - что это сабмит формы
							this.isFormSubmited = true
							/*
							// делаем редирект назад
							this.buttonBlock = 0
							this.$router.go(-1)
							*/
							this.buttonBlock = 0
							this.$router.push('/disks/list')
						}
						// создание VDS
						else if (this.crud === 'vds')
						{
							// ставим признак для роутера - что это сабмит формы
							this.isFormSubmited = true
							// делаем редирект
							let _backUrl = '/vds/list'
							if (this.$store.state.lastWorkedPage[this.crud] && this.$store.state.lastWorkedPage[this.crud] > 1)
								_backUrl = _backUrl + '/' + this.$store.state.lastWorkedPage[this.crud]
							this.$router.push(_backUrl)
						}
						else
						{
							// если это было создание тикета
							if (this.crud === 'ticket' && this.action === 'create')
							{
								// выделим последную запись с которой работали
								if (_dt.ticket && _dt.ticket.ticket_id)
								{
									if (this.$store.state.user_type === 'client') {
										// ставим признак для роутера - что это сабмит формы
										this.isFormSubmited = true
										// делаем редирект в просмотр тикета
										this.$router.push('/ticket/view/' + _dt.ticket.ticket_id)
										// тут все
										return
									} else {
										this.$store.commit('setLastRow', { 'crud': this.crud, 'id': _dt.ticket.ticket_id })
										this.setLocalSuccessMessage(_dt.title)
									}
								}
							}

							// ставим признак для роутера - что это сабмит формы
							this.isFormSubmited = true
							// просто делаем редирект на список
							let _backUrl = '/' + this.crud + '/list'
							if (this.$store.state.lastWorkedPage[this.crud] && this.$store.state.lastWorkedPage[this.crud] > 1)
								_backUrl = _backUrl + '/' + this.$store.state.lastWorkedPage[this.crud]
							this.$router.push(_backUrl)
						}

						return
					}

					// если пришел редирект
					if (_dt && _dt['status'] === 'redirect' && _dt['url'] && String(_dt['url']).length)
					{
						// ставим признак для роутера - что это сабмит формы
						this.isFormSubmited = true
						// делаем редирект
						let url = _dt['url']
						if (url[0] !== '/') url = '/' + url
						this.$router.push(url)
						return
					}

					// если есть ошибки и поля
					if (_dt && _dt['status'] === 'error' && _dt['fields'])
					{
						let _txtError = ''
						let _isFieldError = false
						// бежим по всем полям
						for (let k in _dt['fields'])
						{
							if (_dt['fields'][k] && Array.isArray(_dt['fields'][k]) && _dt['fields'][k].length)
							{
								// ищем поле, для которого указана ошибка
								let _fld = this.findField(k)
								// если такое поле есть - ставим все сообщения
								if (_fld)
								{
									_isFieldError = true
									_fld['_errMsg'] = this.localeFtc(_dt['fields'][k].join(' <br> '))
									EventBus.$emit('w5-set-field-error')
								}
								else
								{
									let _m = k.match(/^params\[(.*)\]$/i)
									if (_m && _m.length && _m[1])
									{
										_txtError += String(_m[1]).toUpperCase() + ': ' + this.localeFtc(_dt['fields'][k].join(' <br> '))
									}
									else _txtError += this.localeFtc(_dt['fields'][k].join(' <br> '))
								}
							}
						}
						if (_txtError) this.localErrorMessage = _txtError
						if (_isFieldError) this.MoveToFieldWithError()
						// на этом все
						this.buttonBlock = 0
						return
					}
					// иная ошибка
					this.localErrorMessage = this.formatRequestError(resPost)
					this.buttonBlock = 0
				},
				// отрицательный ответ сервера
				resPost => {
					// ошибка
					this.localErrorMessage = this.formatRequestError(resPost)
					this.buttonBlock = 0
				}
			)

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		},
		//---------------------------------------------------------------------
		// сабмит формы ISO
		//---------------------------------------------------------------------
		submitIsoForm() {
			// чистим сообщения
			this.localErrorMessage = ''
			this.localSuccessMessage = ''

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// проверка полей для предварительного запроса
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// аккаунт
			let _fieldAccount = this.findField('account_id')
			if (!_fieldAccount || !_fieldAccount.value)
			{
				if (this.$store.state.user_type === 'admin')
					_fieldAccount._errMsg = 'error/required_field'
				else
					this.localErrorMessage = 'error/app_internal'
				return
			}

			// адрес микросервиса ISO
			let _fieldFile = this.findField('file')
			if (!_fieldFile || !_fieldFile.value || !_fieldFile.host)
			{
				this.localErrorMessage = 'error/app_internal'
				return
			}
			// сразу запомним глобально адрес ISO-апи и токен файла
			this.isoFormFileHost = _fieldFile.host
			this.isoFormFileToken = _fieldFile.value
			// и обнулим прогресс
			this.isoFormFileProgress = ''

			// тип
			let _fieldType = this.findField('load_type')
			if (!_fieldType || !_fieldType.value)
			{
				this.localErrorMessage = 'error/app_internal'
				this.buttonBlock = 0
				return
			}
			if (_fieldType.value !== 'download' && _fieldType.value !== 'library' && _fieldType.value !== 'upload')
			{
				_fieldType._errMsg = 'upload/incorrect_filetype'
				this.buttonBlock = 0
				this.MoveToFieldWithError()
				return
			}

			// значение для отправки
			let _postData = {}

			// получим значение поля
			let _field = this.findField(_fieldType.value)
			if (!_field)
			{
				this.localErrorMessage = 'error/app_internal'
				this.buttonBlock = 0
				return
			}
			if (!_field.value)
			{
				_field._errMsg = 'person/error_required'
				this.buttonBlock = 0
				this.MoveToFieldWithError()
				return
			}

			// upload
			if (_fieldType.value === 'upload')
			{
				_postData.file = _field.value
			}
			// download
			if (_fieldType.value === 'download')
			{
				_postData.url = _field.value
			}
			// library
			if (_fieldType.value === 'library')
			{
				_postData.name = _field.value
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// сразу лочим кнопку и поля
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (this.buttonBlock <= 0) this.buttonBlock = 1
			this.$set(_fieldAccount, 'readonly', true)
			this.$set(_fieldType, 'readonly', true)
			this.$set(_field, 'readonly', true)

			// производим сам запрос
			let _url = _fieldFile.host + '/' + _fieldType.value + '/' + _fieldFile.value

			if (_fieldType.value === 'upload')
			{
				// даем команду компоненту на закачку файла
				EventBus.$emit('w5-iso-form-upload', _url)
				// на этом все
				return
			}

			$.post(_url, _postData)
			.done((answer, x, z) => {
				if (answer && answer.status === 'ok')
				{
					// получим статус
					let status = 0
					if (z && z.status) status = z.status

					// если статус 200 - сразу сабмитим форму
					if (status === 200)
					{
						this.submitForm('submit-iso-form')
						return
					}

					// запуск таймера опроса - в таймере если получим статус "done" тогда засабмитим форму
					if (status === 201 || status === 202)
					{
						this.isoFormFileProgress = '...'
						this.isoFormTimer = setInterval(this.isoFormTimerFunc, 3000)
						return
					}
				}

				// разлочим поля
				this.$set(_fieldAccount, 'readonly', false)
				this.$set(_fieldType, 'readonly', false)
				this.$set(_field, 'readonly', false)

				// какая то ошибка
				let msg = 'error/app_internal'
				if (z && z.responseJSON && z.responseJSON.text)
					msg = this.localeFtc(z.responseJSON.text)
				// выводим ее
				this.localErrorMessage = msg
				// перезапрашиваем форму с сохранением значений (для рефреша ключа)
				this.isoFormUpdateOnError()
			})
			.fail((error, x, z) => {
				// разлочим поля
				this.$set(_fieldAccount, 'readonly', false)
				this.$set(_fieldType, 'readonly', false)
				this.$set(_field, 'readonly', false)

				// разбор ошибки
				let msg = 'error/app_internal'
				if (error && error.responseJSON && error.responseJSON.text)
					msg = this.localeFtc(error.responseJSON.text)
				// выводим ее
				this.localErrorMessage = msg
				// перезапрашиваем форму с сохранением значений (для рефреша ключа)
				this.isoFormUpdateOnError()
			})
		},
		//---------------------------------------------------------------------
		// перезапрос формы с сохранением введенных данных
		//---------------------------------------------------------------------
		async isoFormUpdateOnError() {
			// если есть таймер - остановим его
			if (this.isoFormTimer)
			{
				clearInterval(this.isoFormTimer)
				this.isoFormTimer = null
			}

			// теперь убьем текущий токен файла
			if (this.isoFormFileHost && this.isoFormFileToken)
			{
				await $.get(this.isoFormFileHost + '/delete/' + this.isoFormFileToken)
			}

			// обнуляем в компоненте
			this.isoFormFileHost = ''
			this.isoFormFileToken = null
			this.isoFormFileProgress = ''

			// сохраним данные формы
			let _key = 'formStorage_' + this.$route.path.replace(/\//g, '_')
			window.sessionStorage.setItem(_key, JSON.stringify(this.formData))

			// просто запрашиваем данные заново
			this.requestData(true)
		},
		//---------------------------------------------------------------------
		// функция которая по таймеру проверяет статус загружаемого ISO
		//---------------------------------------------------------------------
		isoFormTimerFunc() {
			// если нет ни адреса ни токена
			if (!this.isoFormFileHost || !this.isoFormFileToken)
			{
				this.localErrorMessage = 'error/app_internal'
				this.isoFormUpdateOnError()
				return
			}

			// запросим статус загрузки
			let _url = this.isoFormFileHost + '/status/' + this.isoFormFileToken
			$.get(_url)
			.done((answer, x, z) => {
				if (answer)
				{
					// получим статус
					let status = answer.status

					// upload, download, library
					if (status === 'upload' || status === 'download' || status === 'library')
					{
						// это старт задания - ничего не делаем
						return
					}

					// new
					if (status === 'new')
					{
						// это статус ключа - ничего не делаем
						return
					}

					// processing
					if (status === 'processing')
					{
						// это процент выполнения - получим его
						let str = String(answer.status_msg)
						let m = str.match(/(\d+%)/g)
						if (m && m[0])
							this.isoFormFileProgress = m[0]
						return
					}

					// done
					if (status === 'done')
					{
						// задание успешно закончено
						// отменяем таймер
						clearInterval(this.isoFormTimer)
						this.isoFormTimer = null
						// сабмит формы
						this.submitForm('submit-iso-form')
						return
					}
				}

				// какая то ошибка
				// отменяем таймер
				clearInterval(this.isoFormTimer)
				this.isoFormTimer = null

				// разбор ошибки
				let msg = 'error/app_internal'
				if (z && z.responseJSON && z.responseJSON.text)
					msg = this.localeFtc(z.responseJSON.text)
				// выводим ее
				this.localErrorMessage = msg
				// перезапрашиваем форму с сохранением значений (для рефреша ключа)
				this.isoFormUpdateOnError()
			})
			.fail((error, x, z) => {
				// отменяем таймер
				clearInterval(this.isoFormTimer)
				this.isoFormTimer = null

				// разбор ошибки
				let msg = 'error/app_internal'
				if (error && error.responseJSON && error.responseJSON.text)
					msg = this.localeFtc(error.responseJSON.text)
				// выводим ее
				this.localErrorMessage = msg
				// перезапрашиваем форму с сохранением значений (для рефреша ключа)
				this.isoFormUpdateOnError()
			})
		},
		//---------------------------------------------------------------------
		// инициализация начальных данных
		//---------------------------------------------------------------------
		initData(path) {
			// обнуляем основные значения
			this.crud = null
			this.action = null
			this.id = null
			this.localErrorMessage = ''
			this.localSuccessMessage = ''
			this.isFormSubmited = false
			this.clearSettings = false
			this.formInfo = null
			this.outerDiskFormsCache = {}

			// обнуляем флаг измененной формы
			this.$store.commit('changedForm', false)

			// прячем все диалоги
			this.hideMoneyModal()
			this.hideTemplateModal()
			this.hideSshKeyModal()
			this.hidePayerDialogModal()
			this.hideDeleteModal()
			this.hide2FADialogModal()
			this.hideGeneralDialog()

			// парсим входящий URL
			if (path === '/options')
			{
				// получим наименование CRUD
				this.crud = 'options'
				this.action = 'update'
			}
			else
			{
				let _urlParts = path
					.substr(path.charAt(0) === '/' ? 1 : 0)
					.split('/')
				// должны быть минимум две части
				if (_urlParts.length < 2 ||
					!_urlParts[0] || !_urlParts[0].length ||
					!_urlParts[1] || !_urlParts[1].length)
				{
					this.localErrorMessage = 'main/unknown_page'
					return
				}
				// если вторая часть это не "update", "alerts", "clone", "activate" и не "create"
				if (_urlParts[1] !== 'create' && _urlParts[1] !== 'update' && _urlParts[1] !== 'alerts' && _urlParts[1] !== 'clone' && _urlParts[1] !== 'activate' && _urlParts[1] !== 'links')
				{
					this.localErrorMessage = 'main/unknown_page'
					return
				}

				// если это "update" или "clone" и нет третьего параметра
				if ((_urlParts[1] === 'update' || _urlParts[1] === 'clone' || _urlParts[1] === 'links') && (_urlParts[2] === undefined || _urlParts[2] === null || _urlParts[2] === ''))
				{
					this.localErrorMessage = 'main/unknown_page'
					return
				}

				// получим наименование CRUD
				this.crud = _urlParts[0]
				this.action = _urlParts[1]

				// получим ID объекта
				if (_urlParts[2]) this.id = _urlParts[2]

				// частный случай - ipptrpool
				if (this.crud === 'ipptrpool' && this.action === 'create')
				{
					if (!this.id)
					{
						this.localErrorMessage = 'main/unknown_page'
						return
					}
				}

				// частный случай - создание заметки из меню строки
				if (this.$route.path === '/notes/create')
				{
					// нужен ключ в sessionStorage
					let _key = 'w5_' + this.$store.state.user_id + '_notes_create'

					// не задан объект в Vuex
					if (!this.$store.state.createNoteData)
					{
						// в Vuex данных нет - проверим в sessionStorage
						let _objNote = false
						if (window.sessionStorage) _objNote = window.sessionStorage.getItem(_key)
						if (!_objNote)
						{
							// так нигде и не удалось получить данные об объекте
							this.localErrorMessage = 'Не задан объект для заметки'
						}
						else
						{
							// парсим JSON
							let _data = JSON.parse(_objNote)
							if (!_data)
							{
								// так нигде и не удалось получить данные об объекте
								this.localErrorMessage = 'Не задан объект для заметки'
							}
							else
							{
								// запишем в Vuex
								this.$store.commit('createNoteData', _data)
							}
						}
					}
					else
					{
						// сохраним в sessionStorage - для обновления страницы
						// удалятся будет при сохранении формы
						if (window.sessionStorage)
						{
							// записываем данные в sessionStorage
							try {
								window.sessionStorage.setItem(_key, JSON.stringify(this.$store.state.createNoteData))
							}
							catch (_err)
							{
								if (this.$store.state.isDebug) window.DEBUG.error('Uid0: ' + _err.message)
							}
						}
					}
				}
			}
		},
		//---------------------------------------------------------------------
		// запрос данных формы
		//---------------------------------------------------------------------
		requestData(isSilence) {
			// URL по умолчанию
			let _url = this.$route.path

			// частный случай - пришли по ссылке на создание VDS с параметрами группы и тарифа
			// проверим - если есть данные о тарифе и группе в параметрах
			if (this.crud === 'vds' &&
				this.$route && this.$route.params && typeof this.$route.params === 'object' &&
				'groupId' in this.$route.params && 'planId' in this.$route.params)
			{
				// установим куку для себя
				Helper.setCookie(
					'crtvdsplan',
					JSON.stringify({ group: this.$route.params['groupId'], plan: this.$route.params['planId'] }),
					{ 'expires': 60 * 60 * 24, 'domain': Vue.CookieDomain, 'path': '/' })
				// делаем переход без истории на "чистый" url
				this.$router.replace('/vds/create')
				return
			}

			// частные случаи
			if (_url === '/options') _url = this.$store.state.user_type === 'admin' ? '/admin/options' : '/user/options'
			else if (_url === '/iso/create') _url = '/service/create/' + Vue.Constants.SERVICE_TYPE_ISO
			else if (_url === '/vds/create') _url = '/service/create/' + Vue.Constants.SERVICE_TYPE_VDS
			else if (_url === '/certificate/create') _url = '/service/create/' + Vue.Constants.SERVICE_TYPE_SSL
			else if (_url === '/domains/create') _url = '/service/create/' + Vue.Constants.SERVICE_TYPE_DOMAIN
			else if (_url.indexOf('/domains/update') === 0) _url = _url.replace('/domains/', '/service/')
			else if (_url === '/dns/create') _url = '/service/create/' + Vue.Constants.SERVICE_TYPE_DNS
			else if (_url.indexOf('/dns-records/') === 0) _url = _url.replace('/dns-records/', '/dns/')
			else if (_url === '/bonus/activate') _url = '/bonus/convert'
			else if (_url === '/ipptrpool/create') _url += '/' + this.id
			else if (_url === '/disks/create') {
				// если есть уже кеш
				if (this.outerDiskFormsCache[this.outerDiskTypeValue]) {
					try {
						const _data = JSON.parse(this.outerDiskFormsCache[this.outerDiskTypeValue])
						// нужно распарсить поля формы
						this.formData = this.parseFormData(_data)
						// если есть какая то информация
						if ('info' in _data && _data['info']) this.formInfo = _data['info']

						// инициализация поля размера диска минимумом
						let _quantityField = this.findField('quantity')
						if (_quantityField) {
							if (this.action === 'create') {
								if ('min' in _quantityField) {
									_quantityField['value'] = _quantityField.min
								}

								if (this.formInfo && ('cost' in this.formInfo) && !('cost' in _quantityField)) {
									_quantityField['cost'] = this.formInfo.cost
									_quantityField['full_cost'] = this.formInfo.full_cost
									_quantityField['period'] = this.formInfo.period
								}

								if (this.formInfo && ('backup' in this.formInfo) && !('backup' in _quantityField)) {
									_quantityField['backup'] = this.formInfo.backup
								}
							}
						}

						// восстановление значений полей после смены типа диска
						if (this.outerDiskSavedFields) {
							this.$nextTick(() => {
								for (let _key in this.outerDiskSavedFields) {
									let _formOuterDiskForm = this.findField(_key)
									if (_formOuterDiskForm) {
										this.$set(_formOuterDiskForm, 'value', this.outerDiskSavedFields[_key]['value'])
										this.$set(_formOuterDiskForm, '_visible', this.outerDiskSavedFields[_key]['visible'])
									}
								}

								this.outerDiskSavedFields = null
							})
						}

						// обнуляем флаг в этом месте в любом случае
						this.outerDiskRequestType = false

						// на этом тут все
						return
					} catch (e) {
						this.outerDiskFormsCache[this.outerDiskTypeValue] = null
					}
				}
				_url = '/service/create/' + this.outerDiskTypeValue
			}
			else if (_url.indexOf('/disks/update') === 0) _url = _url.replace('/disks/', '/service/')

			// если не нужно показывать лоадер
			if (isSilence === true) this.$store.commit('needShowLoader', false)

			// производим сам запрос формы
			this.forms_Get(_url, false,
				// успешно получили данные
				(data) => {
					// если сразу пришел редирект
					if (data && data.status === 'redirect' && data.url)
					{
						window.location.replace(data.url)
						return
					}

					// обнуляем флаг в этом месте в любом случае
					this.outerDiskRequestType = false

					// включаем лоадер обратно
					this.$store.commit('needShowLoader', true)

					// нужно распарсить поля формы
					this.formData = this.parseFormData(data)

					// если есть какая то информация
					if ('info' in data && data['info']) this.formInfo = data['info']

					// сохраним в кеше
					if (_url === '/service/create/' + this.outerDiskTypeValue) {
						this.outerDiskFormsCache[this.outerDiskTypeValue] = JSON.stringify(data)
					}

					// частный случай - создание заметки из меню строки
					if (this.crud === 'notes' && this.$store.state.createNoteData &&
						this.$store.state.createNoteData['type'] &&
						this.$store.state.createNoteData['id'] &&
						this.$store.state.createNoteData['name'])
					{
						// запишем данные в соответствующие поля
						// type
						let _fieldType = this.findField('object_type')
						if (_fieldType) _fieldType['value'] = this.$store.state.createNoteData['type']
						// id
						let _fieldId = this.findField('object_id')
						if (_fieldId) _fieldId['value'] = this.$store.state.createNoteData['id']
						// name
						let _fieldName = this.findField('object_name')
						if (_fieldName) _fieldName['value'] = this.$store.state.createNoteData['name']

						// очищаем объект в Vuex
						this.$store.commit('createNoteData', false)
					}

					// частный случай - активация бонуса сотрудником из меню строки
					if (this.crud === 'bonus' && this.action === 'activate' && this.$store.state.bonusActivateData)
					{
						// запишем данные в соответствующие поля
						// bonus
						if (this.$store.state.bonusActivateData['bonus'])
						{
							let _fieldBonus = this.findField('bonus_id')
							if (_fieldBonus) _fieldBonus['value'] = this.$store.state.bonusActivateData['bonus']
						}
						// account
						if (this.$store.state.bonusActivateData['account'] &&
							this.$store.state.bonusActivateData['account']['id'] &&
							this.$store.state.bonusActivateData['account']['name'])
						{
							let _fieldAcc = this.findField('account_id')
							if (_fieldAcc)
							{
								_fieldAcc['value'] = this.$store.state.bonusActivateData['account']['id']
								_fieldAcc['__valueName'] = this.$store.state.bonusActivateData['account']['name']
							}
						}

						// очищаем объект в Vuex
						this.$store.commit('bonusActivateData', false)
					}

					// частный случай
					if (this.crud === 'vds' || this.crud === 'certificate')
					{
						// поле группы всегда скрываем - оно будет показано вместе с тарифами
						let _groupField = this.findField('plan_group_id')
						if (this.crud !== 'vds' && _groupField) _groupField['_visible'] = false
						// если задано в Store значение выбранной группы - установим в значение
						if (this.$store.state.vdsGroup && this.$store.state.vdsGroup.currentGroupId)
							_groupField['value'] = this.$store.state.vdsGroup.currentGroupId
					}

					// частный случай
					if (this.crud === 'disks')
					{
						// инициализация поля размера диска минимумом
						let _quantityField = this.findField('quantity')
						if (_quantityField) {
							if (this.action === 'create') {
								if ('min' in _quantityField) {
									_quantityField['value'] = _quantityField.min
								}

								if (this.formInfo && ('cost' in this.formInfo) && !('cost' in _quantityField)) {
									_quantityField['cost'] = this.formInfo.cost
									_quantityField['full_cost'] = this.formInfo.full_cost
									_quantityField['period'] = this.formInfo.period
								}

								if (this.formInfo && ('backup' in this.formInfo) && !('backup' in _quantityField)) {
									_quantityField['backup'] = this.formInfo.backup
								}
							}
						}

						// если есть указание по аккаунту или ДЦ
						if (window && window.sessionStorage)
						{
							if (this.action === 'create')
							{
								let _key = 'w5_' + this.$store.state.user_id + '_outer_disk_create_dc'
								let _dcObj = window.sessionStorage.getItem(_key)
								window.sessionStorage.removeItem(_key)

								let _dcId = null
								let _dcName = null

								try {
									let _dcData = JSON.parse(_dcObj)
									if (_dcData && 'id' in _dcData && 'name' in _dcData)
									{
										_dcId = parseInt(_dcData.id, 10)
										_dcName = String(_dcData.name)
									}
								}
								catch (err) {}

								if (_dcName && !isNaN(_dcId) && _dcId > 0)
								{
									let _dcField = this.findField('datacenter_id')
									if (_dcField)
									{
										this.$set(_dcField, '_storeValue', {
											field: 'datacenter_id',
											value: _dcId,
											name: _dcName
										})
									}
								}
							}

							let _crtFromBackup = window.sessionStorage.getItem('create-outer-disk-from-backup')
							if (_crtFromBackup)
							{
								// конвертируем
								let _crtStore = null
								try {
									_crtStore = JSON.parse(_crtFromBackup)
								}
								catch (e)
								{
									_crtStore = null
								}

								// если есть указание на создание диска из бэкапа
								// если при этом задан аккаунт
								if (_crtStore && _crtStore.account_id)
								{
									// ставим значение аккаунта в форме
									let _accField = this.findField('account_id')
									if (_accField)
									{
										this.$set(_accField, '_storeValue', {
											field: 'account_id',
											value: _crtStore.account_id,
											name: 'a' + _crtStore.account_id
										})
									}
								}

								if (_crtStore)
								{
									// установим значение поля "options"
									let _optionsField = this.findField('options')
									if (_optionsField)
									{
										this.$set(_optionsField, '_storeValue', {
											field: 'options',
											value: true
										})
									}
								}
							}
						}

						// восстановление значений полей после смены типа диска
						if (this.outerDiskSavedFields) {
							this.$nextTick(() => {
								for (let _key in this.outerDiskSavedFields) {
									let _formOuterDiskForm = this.findField(_key)
									if (_formOuterDiskForm) {
										this.$set(_formOuterDiskForm, 'value', this.outerDiskSavedFields[_key]['value'])
										this.$set(_formOuterDiskForm, '_visible', this.outerDiskSavedFields[_key]['visible'])
									}
								}

								this.outerDiskSavedFields = null
							})
						}
					}

					// частный случай - создание VDS
					if (this.crud === 'vds')
					{
						// проверим куку на определенный тариф (и группу)
						let _Cookie = Helper.getCookie('crtvdsplan')
						// сразу удалим куку
						Helper.deleteCookie('crtvdsplan')

						// если есть кука
						if (_Cookie)
						{
							// конвертируем
							let _planCookie = null
							try {
								_planCookie = JSON.parse(_Cookie)
							}
							catch (e)
							{
								_planCookie = null
							}

							// если данные успешно получены
							if (_planCookie && typeof _planCookie === 'object' && 'plan' in _planCookie && 'group' in _planCookie)
							{
								// получим числовой ID тарифа и группы
								let _planId = parseInt(_planCookie['plan'])
								let _groupId = parseInt(_planCookie['group'])

								// если задана ОС
								let _templateId = null
								if ('template' in _planCookie)
								{
									_templateId = parseInt(_planCookie['template'])
								}

								// проверка
								if (!isNaN(_planId) && _planId >= 0 && !isNaN(_groupId) && _groupId >= 0)
								{
									// установим значение поля, если такое поле есть - обработка будет в самом компоненте planComponent
									let _planField = this.findField('plan_id')
									if (_planField)
										this.$set(_planField, 'cookieValue', _planId)

									// если задана ОС
									if (!isNaN(_templateId) && _templateId >= 0)
									{
										let _templateField = this.findField('template_id')
										if (_templateField)
											this.$set(_templateField, 'cookieValue', _templateId)
									}

									// установим группу
									let _groupField = this.findField('plan_group_id')
									if (_groupField && _groupField.list && _groupField.list.length)
									{
										// ищем в списке групп заданую группу
										let fnd = _groupField.list.some(item => {
											if (String(item.id) === String(_groupId))
											{
												// установка группы по умолчанию
												this.$store.commit('setVdsGroupId', _groupId)

												// установка начальных значений
												_groupField['_oldValue'] = String(_groupId)
												_groupField['_emptyValue'] = String(_groupId)
												_groupField['value'] = Helper.apiGroupFromOneGroup(_groupId)
												return true
											}
										})

										if (fnd)
										{
											this.$nextTick(() => {
												let _grf = this.findField('plan_group_id')
												if (_grf) this.fieldChanged(_grf)
											})
										}
									}
								}
							}
						}

						// частный случай - резервирование IP
						let _reserveIpField = this.findField('reserve_ip')
						if (_reserveIpField && _reserveIpField['list'] && Array.isArray(_reserveIpField['list']))
						{
							// ищем в списке - есть ли уже пустое значение
							let _found = _reserveIpField['list'].some(obj => (obj && String(obj.id) === '-1000'))

							// добавим возможность выбора пустого значения
							if (!_found)
							{
								_reserveIpField['list'].unshift({
									'id': -1000,
									'name': this.localeFtc('main/not_use')
								})
							}
						}

						// всегда проверяем поле с ключами
						let _sshField = this.findField('sshkey_id')

						// если есть какие то элементы
						if (_sshField && _sshField['list'] && _sshField['list'].length)
						{
							// ищем в списке - есть ли уже пустое значение
							let _found = _sshField['list'].some(obj => (obj && String(obj.id) === '-1000'))

							// добавим возможность выбора пустого значения
							if (!_found)
							{
								_sshField['list'].unshift({
									//'id': 'emptyValue',
									'id': -1000,
									'name': this.localeFtc('sshkey/not_use')
								})
							}
						}
						else
						{
							// если ключей нет - у клиентов меняем тип поля на кнопку создания
							if (this.$store.state.user_type === 'client' && this.isAccess('sshkey/create'))
							{
								_sshField['type'] = 'simpleButton'
								_sshField['buttonFunction'] = () => {
									if (!this.sshKeyFields)
									{
										// запрос формы
										this.$http.get(this.APIServerUrl + '/sshkey/create').then(
											// success
											res => {
												// получаем ответ
												let _dt = res && res.data && typeof res.data === 'object' ? res.data : false
												// если ответ корректный
												if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form')
												{
													// запоминаем данные
													let _flds = this.parseFormData(_dt)
													this.sshKeyFields = _flds
													// просто показываем диалог
													EventBus.$emit('w5-body-scroll-disable')
													this.showSshKeyModal = true
													// на этом все
													return
												}

												// ошибка сервера
												this.localErrorMessage = this.formatRequestError(res)
											},
											// fail
											res => {
												// ошибка сервера
												this.localErrorMessage = this.formatRequestError(res)
											}
										)
									}
									else
									{
										// чистим поля
										let _rows = this.sshKeyFields.fields
										if (!_rows || !Array.isArray(_rows)) return

										// бежим по всем полям
										_rows.forEach((item) => {
											// смотрим только строки которые определены и являются массивами
											if (item && Array.isArray(item))
											{
												item.forEach((field, idx, arr) => {
													// смотрим только поля с названиями
													if (field['_field_name'])
														delete field.value
												})
											}
										})
										// просто показываем диалог
										EventBus.$emit('w5-body-scroll-disable')
										this.showSshKeyModal = true
									}
								}
								_sshField['buttonText'] = 'sshkey/create_button'
							}
						}

						// частный случай - прячем поля в форме
						if (this.action === 'create')
						{
							// поле бэкапа
							let _backupField = this.findField('backup_id')
							if (_backupField) _backupField._visible = false
							// и поле ISO
							let _isoField = this.findField('iso_id')
							if (_isoField) _isoField._visible = false
						}

						// если есть указание по аккаунту
						if (window && window.sessionStorage)
						{
							let _crtFromBackup = window.sessionStorage.getItem('create-vds-from-backup')
							if (_crtFromBackup)
							{
								// конвертируем
								let _crtStore = null
								try {
									_crtStore = JSON.parse(_crtFromBackup)
								}
								catch (e)
								{
									_crtStore = null
								}

								// если есть указание на создание VDS из бэкапа
								// если при этом задан аккаунт
								if (_crtStore && _crtStore.account_id)
								{
									// ставим значение аккаунта в форме
									let _accField = this.findField('account_id')
									if (_accField)
										this.$set(_accField, '_storeValue', {
											field: 'account_id',
											value: _crtStore.account_id,
											name: 'a' + _crtStore.account_id
										})
								}
							}
						}
					}

					// частный случай - создание сертификата
					if (this.crud === 'certificate' && this.action === 'create')
					{
						// проверим куку на определенный тариф
						let _Cookie = Helper.getCookie('crtsslplan')
						// сразу удалим куку
						Helper.deleteCookie('crtsslplan')

						// если есть кука
						if (_Cookie)
						{
							// конвертируем
							let _planId = parseInt(_Cookie, 10)
							if (isNaN(_planId)) _planId = -1

							// проверка
							if (_planId >= 0)
							{
								// установим значение поля, если такое поле есть - обработка будет в самом компоненте planComponent
								let _planField = this.findField('plan_id')
								if (_planField)
									this.$set(_planField, 'cookieValue', _planId)
							}
						}
					}

					// частный случай - пополнение баланса клиентом или автоплатеж
					if ((this.crud === 'operation' && this.action === 'create' && this.$store.state.user_type === 'client') ||
						this.crud === 'paymentauto')
					{
						// поле с суммой
						let _sumField = this.findField('summa')
						// если нашли поле
						if (_sumField)
						{
							// если это пополнение баланса пользователем и указана сумма по умолчанию
							if (this.crud === 'operation' && this.action === 'create' && this.$store.state.user_type === 'client' && this.$store.state.operationSumNew)
								_sumField['value'] = this.$store.state.operationSumNew

							this.$nextTick(() => {
								EventBus.$emit('form-client-operation-create', _sumField['value'])
								this.onBlur(this.findField('summa'))
							})
						}

						// поле с сохраненными способами платежа
						let _saved = this.crud === 'operation'
							? this.findField('saved')
							: this.findField('saved_id')

						if (_saved)
							_saved.type = 'savedPayments'
					}

					// частный случай - изменение профиля пользователя
					if (this.crud === 'options' && this.action === 'update' && this.refreshMiniAvatar === true)
					{
						// отключаем флаг
						this.refreshMiniAvatar = false
						// ищем поле с файлом аватара
						let _avatarField = this.findField('file')
						// если поле найдено и у нее задано значение
						if (_avatarField && _avatarField['value'])
						{
							// меняем путь к аватару у пользователя в Vuex
							this.$store.commit('setAvatarPath', _avatarField['value'])
						}
						// нужно установить заного старые данные
						this.formData.fields.forEach(row => {
							if (row && Array.isArray(row))
							{
								row.forEach(f => {
									// ставим "старое" значение
									if (f.value !== null && f.value !== undefined) f['_oldValue'] = f.value
									// обнуляем поля
								})
							}
						})
						// обнулить флаг измененной формы
						this.$store.commit('changedForm', false)
					}

					// частный случай
					if (this.crud === 'rackdevice' && this.action === 'links')
					{
						// нужно добавить пустые значения
						this.formData.fields.forEach(row => {
							if (row && Array.isArray(row))
							{
								row.forEach(f => {
									if (f && f._field_name && f._field_name.indexOf('device_id') === 0 && f.type === 'list' && f.list)
									{
										f['list'].unshift({
											'id': 'emptyValue',
											'name': this.localeFtc('main/free')
										})
									}

									if (f && f._field_name && f._field_name.indexOf('from') === 0 && f.type === 'text' && f.readonly)
									{
										// новый тип
										f.type = 'clearText'
										// подтип
										f.__subtype = 'rackdevice-from'
										// новый реактивный флаг - подключен порт или нет
										let m = f._field_name.match(/^from\[(\d+)\]$/)
										if (m && m.length && m[1])
										{
											let _portField = this.findField('port_id[' + m[1] + ']')
											if (_portField)
												this.$set(f, '__isPortActive', Boolean(_portField.value))
										}
									}
								})
							}
						})
					}

					// частный случай - изменение уведомлений пользователя
					if (this.crud === 'user' && this.action === 'alerts')
					{
						// нужно установить заного старые данные
						this.formData.fields.forEach(row => {
							if (row && Array.isArray(row))
							{
								row.forEach(f => {
									// ставим "старое" значение
									if (f.type === 'boolean')
									{
										if (f.value !== null && f.value !== undefined && f.value !== false) f['_oldValue'] = true
										else f['_oldValue'] = false
									}
									else if (f.value !== null && f.value !== undefined) f['_oldValue'] = f.value
									// обнуляем поля
								})
							}
						})
						// обнулить флаг измененной формы
						this.$store.commit('changedForm', false)
					}

					// частный случай - создание тикета
					if (this.crud === 'ticket' && this.action === 'create')
					{
						// если из вкладки по отделу - должен быть указан отдел
						if (this.$store.state.ticketData.currentDepartmentId)
						{
							let _depField = this.findField('department_id')
							_depField['value'] = this.$store.state.ticketData.currentDepartmentId
						}

						// если по email'y - должен быть указан email
						if (this.$store.state.createTicketEmail && this.$store.state.createTicketEmail.email)
						{
							let _whomField = this.findField('whom')
							_whomField['value'] = 'email'

							let _emailField = this.findField('email')
							_emailField['value'] = this.$store.state.createTicketEmail.email
						}

						// если есть указание по аккаунту
						if (window && window.sessionStorage)
						{
							let _crtFrom = window.sessionStorage.getItem('create-ticket-for-account')
							if (_crtFrom)
							{
								// сразу чистим
								window.sessionStorage.removeItem('create-ticket-for-account')

								// конвертируем
								let _crtStore = null
								try {
									_crtStore = JSON.parse(_crtFrom)
								}
								catch (e)
								{
									_crtStore = null
								}

								// если есть указание на создание VDS из бэкапа
								// если при этом задан аккаунт
								if (_crtStore && _crtStore.account_id)
								{
									// ставим значение аккаунта в форме
									let _accField = this.findField('account_id')
									if (_accField)
										this.$set(_accField, '_storeValue', {
											field: 'account_id',
											value: _crtStore.account_id,
											name: 'a' + _crtStore.account_id
										})
								}
							}
						}
					}

					// частный случай - ищем поля по названию и ставим новый тип
					this.formData.fields.forEach(row => {
						if (row && Array.isArray(row))
						{
							row.forEach(f => {
								// passport
								if (f['validator'] === 'passport')
									f.type = 'passport'
								// phone
								/*
								else if (f._field_name.indexOf('phone') > -1 || f._field_name.indexOf('[fax]') > -1)
									f.type = 'phone'
								*/
								// address
								if (f['validator'] === 'address_post_russian' || f['validator'] === 'address_russian')
									f.type = 'address'
							})
						}
					})

					// если есть сохраненная форма - восстановим ее
					let _fromBlock = false
					let _key = 'formSaver_' + this.$route.path.replace(/\//g, '_')
					let _oldData = false
					if (window.sessionStorage) _oldData = window.sessionStorage.getItem(_key)
					if (_oldData)
					{
						// сразу же удаляем значение из сессии
						window.sessionStorage.removeItem(_key)

						try {
							// парсим JSON
							let _data = JSON.parse(_oldData)

							// установим данные
							if (_data) this.formData = _data
							_fromBlock = true
							this.$nextTick(() => { EventBus.$emit('w5-field-data-from-block') })

							// ставим признак того что форма поменялась
							this.$store.commit('changedForm', this.$route.path)
						}
						catch (_err)
						{
							if (this.$store.state.isDebug) window.DEBUG.error(_err.name + ': ' + _err.message)
							return false
						}
					}
					else
					{
						// если есть сохраненные поля по событию "storage"
						_key = 'formStorage_' + this.$route.path.replace(/\//g, '_')
						_oldData = false
						if (window.sessionStorage) _oldData = window.sessionStorage.getItem(_key)
						if (_oldData)
						{
							// сразу же удаляем значение из сессии
							window.sessionStorage.removeItem(_key)

							try {
								// парсим JSON
								let _data = JSON.parse(_oldData)

								// восстановим значения полей
								if (_data && _data.fields && _data.fields.length)
								{
									for (let x in _data.fields)
									{
										let arr = _data.fields[x]
										if (!arr || !arr.length) continue

										for (let y in arr)
										{
											let f = arr[y]
											if (!f || !f._field_name) continue

											// частный случай
											if (this.crud === 'iso' &&
												this.action === 'create' &&
												f._field_name === 'file')
											{
												// пропустим
												continue
											}

											let ff = this.findField(f._field_name)
											if (!ff) continue

											if ('value' in f)
												ff.value = f.value

											if ('listValue' in f)
												ff.listValue = f.listValue

											if ('_storeValue' in f)
												ff._storeValue = f._storeValue

											if (f._field_name === 'account_id')
											{
												ff.listValue = {
													id: f.value,
													name: 'a' + f.value
												}
											}
										}
									}
								}

								// разблокируем кнопку
								this.buttonBlock = 0
							}
							catch (_err) {}
						}
					}

					// вычисляем условия "reload" и "showif" в следующем тике,
					// так как в этом еще не расставлены значения
					this.$nextTick(() => {
						this.showif()

						// бежим по всем строкам формы
						this.formData.fields.forEach(row => {
							// бежим по всем поля строки
							if (row) row.forEach(fld => {
								this.reloadif(fld['_field_name'])
							})
						})

						// дополнительное заполнение числовых полей
						this.fillNumberFields()

						// если форма уже восстановлена из блокировки приложения
						if (_fromBlock) return

						this.$nextTick(() => {
							// инициализация начальных значений в следующем тике
							// из-за reloadif, поля с новыми значениями еще не отрендерены
							EventBus.$emit('w5-init-form-data')
						})
					})
				},
				// неудача
				() => {
					// включаем лоадер обратно
					this.$store.commit('needShowLoader', true)
					// обнуляем флаг в любом случае
					this.outerDiskRequestType = false
				}
			)
		},
		//---------------------------------------------------------------------
		// есть ли видимые поля в строке
		//---------------------------------------------------------------------
		isVisibleField(row) {
			// по умолчанию не видна
			let _answer = false
			// ищем любое поле с типом не "hidden"
			row.some((item, idx, arr) => {
				// частный случай
				if (item && this.crud === 'vds' && this.action === 'create')
				{
					// поля всегдя видимы
					/*
					if (item['_field_name'] === 'sshkey_id' ||
						item['_field_name'] === 'backup_auto')
					{
						_answer = true
						return true
					}
					*/
					if (item['_field_name'] === 'backup_auto')
					{
						_answer = true
						return true
					}
				}

				// если такое поле есть - значит строка должна быть видима
				if (item && item.type !== 'hidden' && item['_visible'] === true)
				{
					_answer = true
					return true
				}
			})

			// возвращаем результат
			return _answer
		},
		//---------------------------------------------------------------------
		// это поле-разделитель?
		//---------------------------------------------------------------------
		isDividerField(row) {
			// по умолчанию не видна
			let _answer = false
			// ищем любое поле с типом "header"
			row.some((item, idx, arr) => {
				// если такое поле есть
				if (item && item.type === 'header' && item['_visible'] === true)
				{
					_answer = true
					return true
				}
			})

			// возвращаем результат
			return _answer
		},
		//---------------------------------------------------------------------
		// количество видимых полей в строке
		//---------------------------------------------------------------------
		countVisibleFieldsInRow(row) {
			// ответ по умолчанию
			let _answer = 0
			// ищем все видимые поля
			row.forEach(item => {
				if (item && item.type !== 'hidden' && item['_visible'] === true)
				{
					_answer++
				}
			})

			// возвращаем результат
			return _answer
		},
		//---------------------------------------------------------------------
		// нужно заблокировать кнопку формы
		//---------------------------------------------------------------------
		blockFormButton() {
			if (this.buttonBlock > 0) return
			this.buttonBlock++
		},
		//---------------------------------------------------------------------
		// нужно разблокировать кнопку формы
		//---------------------------------------------------------------------
		unblockFormButton() {
			if (this.crud === 'iso' && this.action === 'create') return
			this.buttonBlock--
			if (this.buttonBlock < 0) this.buttonBlock = 0
		},
		//---------------------------------------------------------------------
		// выбрали координаты (crop)
		//---------------------------------------------------------------------
		cropCoords(data) {
			// генерируем событие в общей шине событий
			// нужные поля сами подхватят эти данные
			EventBus.$emit('w5-crop-data', data)
		},
		//---------------------------------------------------------------------
		// изменили параметры
		//---------------------------------------------------------------------
		onParams(params) {
			this.params = params
		},
		//---------------------------------------------------------------------
		// при загрузке ISO возникла ошибка
		//---------------------------------------------------------------------
		onIsoUploadError(text) {
			this.localErrorMessage = text
			this.isoFormUpdateOnError()
		},
		//---------------------------------------------------------------------
		// отменили загрузку ISO
		//---------------------------------------------------------------------
		onIsoUploadCanceled() {
			this.isoFormUpdateOnError()
		},
		//---------------------------------------------------------------------
		// закачка ISO в микросервис успешно закончена
		//---------------------------------------------------------------------
		onIsoUploadFinished() {
			this.submitForm('submit-iso-form')
		},
		//---------------------------------------------------------------------
		// поменялась группа
		//---------------------------------------------------------------------
		onGroupChanged(newGroup) {
			let _groupField = this.findField('plan_group_id')
			if (_groupField) _groupField['value'] = newGroup
			this.fieldChanged(_groupField)
		},
		//---------------------------------------------------------------------
		// поменялось наименование домена
		//---------------------------------------------------------------------
		onDomainName(nameValue) {
			let _field = this.findField('name')
			if (_field) _field['value'] = nameValue
			this.fieldChanged(_field)
		},
		//---------------------------------------------------------------------
		// успешная закачка файла
		//---------------------------------------------------------------------
		onUploadFinished() {
			// рассматриваем частные случаи
			if (this.crud === 'iso')
			{
				// дизаблим кнопку уже здесь
				this.blockFormButton()
				// сабмитим форму
				this.submitForm()
			}
		},
		//---------------------------------------------------------------------
		// метка - удаляют файл или нет
		//---------------------------------------------------------------------
		deleteFileValue(data) {
			if (!data || !data['field'] || !('value' in data)) return
			let _field = this.findField(data['field'])
			// эта операция допустима только для картинок и файлов
			if (!_field || (_field.type !== 'file' && _field.type !== 'image')) return
			// обнулим ошибку
			_field['_errMsg'] = ''
			// ставим метку
			_field['_deleteFile'] = data['value']
			// если это именно удаление - обнуляем основное значение
			if (data['value'] === true) _field['value'] = null
		},
		//---------------------------------------------------------------------
		// поиск поля в formData
		//---------------------------------------------------------------------
		findField(name) {
			// если нет вообще полей
			if (!this.formData.fields) return null

			// поля есть - пробежимся по ним
			let _field = null
			this.formData.fields.some(item => {
				if (item && Array.isArray(item))
				{
					item.some(obj => {
						if (obj && obj['_field_name'] === name)
						{
							_field = obj
							return true
						}
					})

					if (_field) return true
				}
			})

			return _field
		},
		//---------------------------------------------------------------------
		// фокус на поле
		//---------------------------------------------------------------------
		onFocus(field) {
			// чистим ошибку если есть
			field['_errMsg'] = ''

			// если это домен
			if (this.crud === 'domains' && field['_field_name'] === 'plan_id')
			{
				// чистим ошибку и у наимнования домена - это единный компонент
				let _field = this.findField('name')
				if (_field) _field['_errMsg'] = ''
				return
			}

			// если это бэкап
			if (this.crud === 'vds' && field['_field_name'] === 'template_id')
			{
				let _bf = this.findField('backup_id')
				if (_bf) _bf['_errMsg'] = ''

				let _if = this.findField('iso_id')
				if (_if) _if['_errMsg'] = ''

				return
			}

			// если это тариф и ДЦ
			if (this.crud === 'vds' && field['_field_name'] === 'plan_id')
			{
				let _df = this.findField('datacenter_id')
				if (_df) _df['_errMsg'] = ''
			}
			// и наоборот - если это ДЦ и тариф
			if (this.crud === 'vds' && field['_field_name'] === 'datacenter_id')
			{
				let _df = this.findField('plan_id')
				if (_df) _df['_errMsg'] = ''
			}
		},
		//---------------------------------------------------------------------
		// потеря фокуса полем
		//---------------------------------------------------------------------
		onBlur(field) {
			// если это уже сабмит формы - проверка не требуется
			if (this.isFormSubmited) return

			// если нужна транслитерация
			if (this.crud === 'person' && field['_field_name'] && field.value)
			{
				if (String(field['_field_name']).indexOf('[person_r]') > 0)
					EventBus.$emit('w5-transliterate', {
						field: String(field['_field_name']).replace('_r]', ']'),
						value: field.value,
						what: 'fio'
					})

				if (String(field['_field_name']).indexOf('[org_r]') > 0)
					EventBus.$emit('w5-transliterate', {
						field: String(field['_field_name']).replace('_r]', ']'),
						value: field.value,
						what: 'org'
					})
			}

			// для полей в виде массива
			if (/^\w+\[\w+\]/i.test(field['_field_name']))
			{
				// получим валидатор
				let _validator = validatorArrayField.validators[this.crud] ? validatorArrayField.validators[this.crud] : validatorArrayField.personValidators
				// если есть значение и валидатор - проверим им локально
				if (field['value'] !== undefined && field['value'] !== null && field['value'] !== '' &&
					field['validator'] && _validator[field['validator']])
				{
					let _err = ''
					if (field['validator'] === 'date')
						_err = _validator[field['validator']](field['value'], field['format'], field['_field_name'])
					else if (field['validator'] === 'bank_account' || field['validator'] === 'user_account')
						_err = _validator[field['validator']](field['value'], this.form_GetData.fields)
					else
						_err = _validator[field['validator']](field['value'])

					if (_err)
					{
						field['_errMsg'] = _err
						EventBus.$emit('w5-set-field-error')
					}
				}

				// проверка в АПИ не требуется
				return
			}

			// если это оплата и текущее поле - это сумма
			if (
				(this.crud === 'operation' || this.crud === 'paymentauto') &&
				(this.action === 'select' || this.action === 'create') &&
				field['_field_name'] === 'summa')
			{
				// сделаем проверку на минимальную сумму
				let _min = 999999999
				let _val = parseFloat(field['value'])

				if (!isNaN(_val))
				{
					// 1. в поле "saved" -> list -> min
					let _savedField = this.findField(this.crud === 'operation' ? 'saved' : 'saved_id')
					if (_savedField && _savedField.list && _savedField.list.length)
					{
						_savedField.list.forEach(ff => {
							if (ff && 'min' in ff)
							{
								let _minVal = parseFloat(ff['min'])
								if (!isNaN(_minVal) && _minVal < _min) _min = _minVal
							}
						})
					}

					// 2. в поле "payment" -> list -> min
					let _paymentField = this.findField('payment')
					if (_paymentField && _paymentField.list && _paymentField.list.length)
					{
						_paymentField.list.forEach(ff => {
							if (ff && 'min' in ff)
							{
								let _minVal = parseFloat(ff['min'])
								if (!isNaN(_minVal) && _minVal < _min) _min = _minVal
							}
						})
					}

					// 3. если введеное значение меньше минимума
					if (_min < 999999999 && _val < _min)
					{
						// меняем на минимальный минимум с анимацией
						EventBus.$emit('w5-set-money-field-value', {
							'type': field['type'],
							'name': field['_field_name'],
							'value': _min,
							'animation': true
						})
					}
				}
			}

			// проверка поля
			this.verifyField(field)
		},
		//---------------------------------------------------------------------
		// нажали ENTER по полю
		//---------------------------------------------------------------------
		onEnterKeyDown(e) {
			if (e) e.preventDefault()

			// если это в поле создания платежа клиентом
			if (this.crud === 'operation' && this.action === 'create')
			{
				if (!this.isSubmitButtonEnabled) return
			}

			this.submitForm(e)
		},
		//---------------------------------------------------------------------
		// изменение текстового поля с задержкой
		//---------------------------------------------------------------------
		onTextEvent(txt) {
			// это создание тикета клиентом - нужен поиск по QA
			if (this.crud === 'ticket' && this.action === 'create' && this.$store.state.user_type === 'client')
			{
				// сразу проверка
				if (!txt || String(txt).length < 3)
				{
					EventBus.$emit('form-ticket-serach-result', false)
					return
				}

				// делаем запрос на поиск в QA
				// URL по умолчанию
				let _url = Vue.QAUrl + '/api2panel/search'

				// производим сам запрос формы
				this.$http.post(_url, Helper.toFormData({ search: txt })).then(
					// успешно получили данные
					res => {
						if (res && typeof res === 'object' && res.ok === true && res.body && res.body.status)
							EventBus.$emit('form-ticket-serach-result', res.body.answer)
						else
							EventBus.$emit('form-ticket-serach-result', false)
					},
					// не успешный результат
					res => {
						EventBus.$emit('form-ticket-serach-result', false)
					}
				)
			}
		},
		//---------------------------------------------------------------------
		// проверка поля
		//---------------------------------------------------------------------
		verifyField(field) {
			// по умолчанию чистим сообщение об ошибке
			field['_errMsg'] = ''

			// обнуляем флаг в этом месте в любом случае
			this.outerDiskRequestType = false

			// если значение пустое или не задано - проверка не нужна
			if (field.value === undefined || field.value === null || String(field.value) === '') return

			// если есть флаг fake - проверка не нужна
			if (field.fake === true) return

			// если не прошли локальную проверку - ошибка уже записана в переменную
			if (!this.localValidation(field)) return

			// формируем значения для проверки на API-сервере
			let _obj = {}
			let o
			if (field.validate_with)
			{
				let _v = field.validate_with

				if (typeof _v === 'object' && Array.isArray(_v) && _v.length)
				{
					for (let _i in _v)
					{
						o = this.findField(_v[_i])
						// если нет значения в каком то поле из validate_with
						if (o && (o.value === undefined || o.value === null || String(o.value) === ''))
						{
							// если это булево поле - передаем значение false
							if (o.type === 'boolean')
								_obj[_v[_i]] = 0
							// проверять не нужно
							else
								return
						}
						if (o && o.value) _obj[_v[_i]] = o.value
						if (o && o.type === 'boolean') _obj[_v[_i]] = Helper.normalizeBooleanValue(o.value) ? 1 : 0
					}
				}
				else if (typeof _v === 'object')
				{
					for (let _i in _v) if (_v.hasOwnProperty(_i))
					{
						o = this.findField(_v[_i])
						// если нет значения в каком то поле из validate_with - проверять не нужно
						if (o && (o.value === undefined || o.value === null || String(o.value) === ''))
						{
							// если это булево поле - передаем значение false
							if (o.type === 'boolean')
								_obj[_v[_i]] = 0
							// проверять не нужно
							else
								return
						}
						if (o && o.value) _obj[_v[_i]] = o.value
						if (o && o.type === 'boolean') _obj[_v[_i]] = Helper.normalizeBooleanValue(o.value) ? 1 : 0
					}
				}
				else
				{
					o = this.findField(_v)
					// если нет значения в каком то поле из validate_with - проверять не нужно
					if (o && (o.value === undefined || o.value === null || String(o.value) === '')) return
					if (o && o.value) _obj[_v] = o.value
					if (o && o.type === 'boolean') _obj[_v] = Helper.normalizeBooleanValue(o.value) ? 1 : 0
				}
			}

			// формируем URL
			let _url = this.APIServerUrl + this.$route.path
			// частные случаи
			if (this.$route.path === '/options') _url = this.APIServerUrl + '/' + (this.$store.state.user_type === 'client' ? 'user' : 'admin') + '/options'
			else if (this.$route.path === '/iso/create') _url = this.APIServerUrl + '/service/create/' + Vue.Constants.SERVICE_TYPE_ISO
			else if (this.$route.path === '/vds/create') _url = this.APIServerUrl + '/service/create/' + Vue.Constants.SERVICE_TYPE_VDS
			else if (this.$route.path === '/certificate/create') _url = this.APIServerUrl + '/service/create/' + Vue.Constants.SERVICE_TYPE_SSL
			else if (this.$route.path === '/domains/create') _url = this.APIServerUrl + '/service/create/' + Vue.Constants.SERVICE_TYPE_DOMAIN
			else if (this.$route.path.indexOf('/domains/update') === 0) _url = _url.replace('/domains/', '/service/')
			else if (this.$route.path === '/dns/create') _url = this.APIServerUrl + '/service/create/' + Vue.Constants.SERVICE_TYPE_DNS
			else if (this.$route.path.indexOf('/dns-records/') === 0) _url = _url.replace('/dns-records/', '/dns/')
			else if (this.$route.path === '/disks/create') _url = this.APIServerUrl + '/service/create/' + this.outerDiskTypeValue
			else if (this.$route.path.indexOf('/disks/update') === 0) _url = _url.replace('/disks/', '/service/')
			// обнулим хендлеры предыдущих запросов
			this.verifyRequestsHandlers = []
			// делаем запрос на проверку поля
			this.forms_verifyRequest(
				// URL запроса
				_url,
				// данные
				{
					'field': field['_field_name'],
					'value': field['value'],
					'data': _obj
				},
				// callback-функция
				(data) => {
					if (data && data['fields'] && data['fields'][field['_field_name']])
					{
						let _msg = data['fields'][field['_field_name']]
						if (typeof _msg === 'string')
						{
							field['_errMsg'] = _msg
							EventBus.$emit('w5-set-field-error')
						}
						else if (typeof _msg === 'object')
						{
							let _txt = ''
							for (let k in _msg)
								if (_txt === '') _txt = _msg[k]
								else _txt += ' <br> ' + _msg[k]
							field['_errMsg'] = _txt
							EventBus.$emit('w5-set-field-error')
						}
					}
				},
				// функция, которая запоминает хендлеры запросов - что бы их можно было терминировать
				(request) => {
					this.verifyRequestsHandlers.push(request)
				}
			)
		},
		//---------------------------------------------------------------------
		// локальная проверка полей
		//---------------------------------------------------------------------
		localValidation(field) {
			// проверяем только определенные типы
			// если поле невидно - то и проверять нет смысла, передаваться будет как есть
			if (!field['_visible']) return true
			// если значение поля не задано - то и проверять нет смысла, передаваться будет как есть
			if (field['value'] === undefined || field['value'] === null) return true

			// INTEGRE
			if (field.type === 'integer' || field.type === 'int')
			{
				// получим значение в виде строки
				let v = String(field.value).trim()
				// уберем пробелы
				v = v.replace(/ /g, '')
				// парсим в INT
				let r = parseInt(v)
				// если не удалось
				if (isNaN(r))
				{
					field['_errMsg'] = 'validators/error_int'
					return false
				}

				// если значение не изменилось
				if (v === String(r)) return true
				// значение изменилось
				field['_errMsg'] = 'validators/error_int'
				return false
			}

			// FLOAT || MONEY
			if (field.type === 'float' || field.type === 'money')
			{
				// получим значение в виде строки
				let v = String(field.value).trim()
				// уберем пробелы
				v = v.replace(/ /g, '')
				// парсим в FLOAT
				let r = parseFloat(v)
				// если не удалось
				if (isNaN(r))
				{
					field['_errMsg'] = 'validators/error_float'
					return false
				}

				// доп.проверка
				if (!Helper.isNumeric(String(r)))
				{
					// значение не число
					field['_errMsg'] = 'validators/error_float'
					return false
				}
			}

			// EMAIL
			if (field.type === 'email')
			{
				if (Helper.validateEmail(field.value)) return true
				// проверка не пройдена
				field['_errMsg'] = 'validators/error_email'
				return false
			}

			// частные случаи
			if (this.crud === 'paymentauto' && field._field_name === 'summa')
			{
				let _savedField = this.findField('saved_id')
				if (_savedField && _savedField.value !== undefined && _savedField.value !== null && !isNaN(_savedField.value) &&
					_savedField.list && _savedField.list.length)
				{
					// найдем сохраненный способ
					let saved = null
					_savedField.list.some(i => {
						if (i && i.id === _savedField.value)
						{
							saved = i
							return true
						}
					})
					if (saved)
					{
						// получим значение в виде строки
						let v = String(field.value).trim()
						// уберем пробелы
						v = v.replace(/ /g, '')
						// парсим в FLOAT
						let r = parseFloat(v)

						// min
						let _min = saved['min']
						if (_min === undefined || _min === null || isNaN(_min) || _min === '') _min = 0
						_min = parseFloat(_min)

						// max
						let _max = saved['max']
						if (_max === undefined || _max === null || isNaN(_max) || _max === '') _max = 0
						_max = parseFloat(_max)

						// проверки
						if (r <= 0 || r < _min)
						{
							field['_errMsg'] = this.formater_capitalizeFirstChar(this.localeFtc('request/status_error: payment/min'))
							return false
						}

						if (_max && r > _max)
						{
							field['_errMsg'] = this.formater_capitalizeFirstChar(this.localeFtc('request/status_error: payment/max'))
							return false
						}
					}
				}
			}

			// для остальных типов все ОК
			return true
		},
		//---------------------------------------------------------------------
		// поменялось значение поля
		//---------------------------------------------------------------------
		fieldChanged(field) {
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если какие то данные в форме изменились - ставим флаг измененной формы
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// по умолчанию флаг обнуляется - так как могли вернуть старое значение
			this.$store.commit('changedForm', false)

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// частный случай: форма оплаты клиентом
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if ((this.crud === 'operation' && this.action === 'create' && this.$store.state.user_type === 'client') ||
				this.crud === 'paymentauto')
			{
				// если это поле ввода суммы при пополнении баланса клиентов, нужно сделать сообщение
				if (field['_field_name'] === 'summa')
				{
					field['_errMsg'] = ''
					EventBus.$emit('form-client-operation-create', field['value'])
				}

				// если есть указание обнулить поле
				if (field['unselect'])
				{
					EventBus.$emit('w5-clear-list-field', field['unselect'])
				}

				if (field['_field_name'] === 'saved' && field['value'])
				{
					if (this._computedWatchers &&
					this._computedWatchers.isSubmitButtonEnabled &&
					this._computedWatchers.isSubmitButtonEnabled.run)
					{
						this._computedWatchers.isSubmitButtonEnabled.run()
						this.$forceUpdate()
					}
				}
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// частный случай: связь оборудования
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (this.crud === 'rackdevice' && this.action === 'links' &&
				field._field_name && field._field_name.indexOf('port_id') === 0)
			{
				// нельзя давать выбрать одинаковый порт для одного и того же оборудования
				// 1.1. определим индекс полей
				let m = field._field_name.match(/^port_id\[(\d+)\]$/)
				if (m && m.length && m[1])
				{
					//---------------------------------------------------------
					// отслеживаем порт
					//---------------------------------------------------------
					// 1.2. если нашли индекс - ищем оборудование
					let deviceField = this.findField('device_id[' + m[1] + ']')
					if (deviceField)
					{
						// 1.3. нашли наше оборудование - получим его значение
						let deviceValue = deviceField.value

						// 2.1. ищем поля "device_id" с таким же значением
						// и уже установленным таким же портом
						let _found = false
						this.formData.fields.some(item => {
							if (item && Array.isArray(item))
							{
								item.some(obj => {
									if (obj && obj._field_name &&
										obj._field_name.indexOf('device_id') === 0 &&
										obj._field_name !== deviceField._field_name &&
										obj.value === deviceValue)
									{
										// 2.2. нашли такое же оборудование, но поле другое
										// ищем его порт
										let n = obj._field_name.match(/^device_id\[(\d+)\]$/)
										if (n && n.length && n[1])
										{
											let portField = this.findField('port_id[' + n[1] + ']')
											if (portField && portField.value === field.value)
											{
												_found = true
												return true
											}
										}
									}
								})

								if (_found) return true
							}
						})

						// если нашли
						if (_found)
						{
							// восстановим старое значение
							EventBus.$emit('w5-set-list-field-value', {
								name: field._field_name,
								value: field.perviousValues && field.perviousValues.obj ? field.perviousValues.obj : null
							})

							// не пускаем дальше
							return
						}
					}

					//---------------------------------------------------------
					// отслеживаем флаг - подключен в итоге порт или нет
					//---------------------------------------------------------
					let fromField = this.findField('from[' + m[1] + ']')
					if (fromField)
					{
						fromField.__isPortActive = Boolean(field.value)
					}
				}
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// каждый раз вычисляем условия "showif" для всех полей с таким условием
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			this.showif()

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// каждый раз вычисляем условия "reload"
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			this.reloadif(field['_field_name'])

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		},
		//---------------------------------------------------------------------
		// сравнивает поля в свойстве "reload" с fieldName
		//---------------------------------------------------------------------
		reloadifFieldNameEqual(reloadValue, fieldName) {
			if (!reloadValue || !fieldName) return false

			// если это сложный объект
			if (typeof reloadValue === 'object')
			{
				// если это массив
				if (Array.isArray(reloadValue))
				{
					return reloadValue.some(name => {
						if (name === fieldName) return true
					})
				}
				// это просто объект
				else
				{
					for (let _key in reloadValue) if (reloadValue.hasOwnProperty(_key))
					{
						if (_key === fieldName) return true
					}

					return false
				}
			}

			// по умолчанию
			return reloadValue === fieldName
		},
		//---------------------------------------------------------------------
		// делает подгрузку данных
		//---------------------------------------------------------------------
		reloadifLoading(changedFieldName, Field, forceValue) {
			// ищем указанное поле - поле которое изменилось
			let _field = this.findField(changedFieldName)
			if (!_field && this.$store.state.isDebug)
				return window.DEBUG.error('Ureloadif0: поле указанное в "reload" не найдено')

			// получим URL у поля которое должно перегрузиться
			let _url = Field['url']
			if (!_url && this.$store.state.isDebug)
				return window.DEBUG.error('Ureloadif1: в поле с признаком "reload" не задан URL')

			// получим значение поля, которое указано в "reload" - то есть которое изменилось
			let _values = []
			if (_field && 'value' in _field)
			{
				if (Array.isArray(_field['value']))
					_field['value'].forEach((i) => {
						if (i !== undefined && i !== null && i !== '')
							_values.push(i)
					})
				else
				{
					if (_field['value'] !== undefined && _field['value'] !== null && _field['value'] !== '')
						_values.push(_field['value'])
				}
			}

			// если указано значение которое нужно использовать в любом случае
			if (forceValue)
			{
				_values.push(forceValue)
			}

			// если нет ни одного значения - подгрузка не нужна
			if (!_values.length) return

			// если "reload" содержит список полей (массив)
			if (Array.isArray(Field['reload']))
			{
				// есть ли пустые значения
				let _isEmptyValue = false
				// ищем все поля
				Field['reload'].forEach(_f => {
					// найдем это поле
					let _ff = this.findField(_f)
					// если нашли
					if (_ff)
					{
						// проверим значение
						if (_ff['value'] !== undefined && _ff['value'] !== null && _ff['value'] !== '')
						{
							// подставляем значения в URL
							_url = _url.replace(_f + '=', _f + '=' + _ff['value'])
						}
						// есть хотя бы одно пустое значение (в поле не задано значение)
						else _isEmptyValue = true
					}
					else _isEmptyValue = true
				})
				// если есть поля с незаданными значениями - подгрузка не нужна
				if (_isEmptyValue) return
				// теперь формируем URL окончательно
				_url = this.APIServerUrl + _url
			}
			// по умолчанию
			else _url = this.APIServerUrl + _url + _values.join(',')

			// частный случай
			if (this.crud === 'document' && Field._field_name === 'operation_id' && _url.indexOf('type=&') > 0)
			{
				// нужно вставить тип
				let _typeField = this.findField('type')
				if (_typeField)
				{
					let _val = _typeField.value
					if (_val)
						_url = _url.replace('type=&', `type=${_val}&`)
				}
			}

			// производим запрос
			this.cachedRequestGet(_url).then(
				// рассматриваем только успешный ответ
				res => {
					// получаем ответ
					let _dt = res && res.data && typeof res.data === 'object' ? res.data : false
					// если ответ корректный - меняем список
					if (_dt && _dt['status'] === 'ok')
					{
						let resultList = _dt['result'] && Array.isArray(_dt['result']) ? _dt['result'] : []
						// обновляем что нужно обновить
						// для поля типа "list"
						if (Field['type'] === 'list' ||
							(Field['type'] === 'urlButton' && Field['_field_name'] === 'person_id') ||
							(Field['type'] === 'savedPayments' && Field['_field_name'] === 'saved_id'))
						{
							// частные случаи - добавление элементов
							if (this.crud === 'vds' && Field['_field_name'] === 'sshkey_id')
							{
								// ищем в списке - есть ли уже пустое значение
								let _found = resultList.some(obj => (obj && String(obj.id) === '-1000'))

								if (!_found)
								{
									resultList.unshift({
										//'id': 'emptyValue',
										'id': -1000,
										'name': this.localeFtc('sshkey/not_use')
									})
								}
							}
							if (this.crud === 'vds' && Field['_field_name'] === 'reserve_ip')
							{
								// ищем в списке - есть ли уже пустое значение
								let _found = resultList.some(obj => (obj && String(obj.id) === '-1000'))

								if (!_found)
								{
									resultList.unshift({
										'id': -1000,
										'name': this.localeFtc('main/not_use')
									})
								}

								// теперь ищем в новом списке текущее значение
								const _reserveIpField = this.findField('reserve_ip')
								if (_reserveIpField && 'value' in _reserveIpField)
								{
									_found = resultList.some(obj => (obj && String(obj.id) === String(_reserveIpField.value)))
									// если не нашли - установим not_use
									if (!_found)
									{
										_reserveIpField.value = -1000
										this.$nextTick(() => {
											EventBus.$emit('w5-set-list-field-value', {
												name: 'reserve_ip',
												value: {
													'id': -1000,
													'name': this.localeFtc('main/not_use')
												}
											})
										})
									}
								}
							}

							if (this.crud === 'server' && Field['_field_name'] === 'groups')
							{
							}
							// установим полученный список
							this.$set(Field, 'list', resultList)

							// передадим в эфир
							EventBus.$emit('w5-vds-create-field-reloaded', Field._field_name)

							// если это форма создания VDS
							if (this.crud === 'vds' && this.action === 'create' && Field._field_name === 'template_id' && window && window.sessionStorage)
							{
								// если есть указание на создание VDS из бэкапа и загрузился список шаблонов
								let _crtFromBackup = window.sessionStorage.getItem('create-vds-from-backup')
								if (_crtFromBackup)
								{
									// нужно переключится на вкладку бэкапов
									// и тогда сработает запрос списка бэкапов
									this.$nextTick(() => {
										EventBus.$emit('w5-change-active-tab', 'backup')
									})
								}
							}
						}
					}
				}
			)
		},
		//---------------------------------------------------------------------
		// обновляем все поля со свойством "reload" = changedFieldName
		//---------------------------------------------------------------------
		reloadif(changedFieldName) {
			// бежим по всем полям
			let _rows = this.formData['fields']
			if (!_rows || !Array.isArray(_rows)) return

			// бежим по всем полям - смотрим на свойство "reload"
			_rows.forEach((item) => {
				// смотрим только строки которые определены и являются массивами
				if (item && Array.isArray(item))
				{
					item.forEach((field, idx, arr) => {
						// смотрим только поля с "reload" = changedFieldName
						if (this.reloadifFieldNameEqual(field['reload'], changedFieldName))
						{
							// если поле видимо
							if (field['_visible'] === true)
							{
								this.reloadifLoading(changedFieldName, field)
							}
							// если поле не видимо
							else
							{
								// тут идут частные случаи - когда нужно все равно загрузить поле
								if (
									(this.crud === 'domains' && field['_field_name'] === 'person_id') ||
									(this.crud === 'vds' && field['_field_name'] === 'reserve_ip') ||
									(this.crud === 'vds' && field['_field_name'] === 'sshkey_id' && this.$store.state.user_type === 'admin')
									)
								{
									this.reloadifLoading(changedFieldName, field)
								}
								else if (this.crud === 'vds' || this.crud === 'disks')
								{
									if (field['_field_name'] === 'backup_id' || field['_field_name'] === 'iso_id')
										this.reloadifLoading(changedFieldName, field)
								}
							}
						}
					})
				}
			})
		},
		//---------------------------------------------------------------------
		// вычисляем значение "showif" для всех полей
		//---------------------------------------------------------------------
		showif() {
			// бежим по всем полям
			let _rows = this.formData['fields']
			if (!_rows || !Array.isArray(_rows)) return

			// готовим объекты, где собираем значения и выражения
			let _values = {}
			let _expressions = {}

			// бежим по всем полям - собираем значения и выражения
			_rows.forEach((item) => {
				// смотрим только строки которые определены и являются массивами
				if (item && Array.isArray(item))
				{
					item.forEach((field, idx, arr) => {
						// смотрим только поля с названиями
						if (field['_field_name'])
						{
							// заполняем объект со значениями
							_values[field['_field_name'].replace(/\[/g, '__').replace(/]/g, '__')] = field['value']

							// если есть выражение для данного поля
							if (field['showif'])
							{
								// получим выражение
								let _expr = field['showif']
								// подменяем в выражении переменные
								if (_expr.indexOf('[') !== -1 && _expr.indexOf(']') !== -1 && _expr.indexOf(' in ') !== -1)
								{
									// условие: var not in [array]
									if (_expr.indexOf(' not in ') !== -1)
									{
										// var not in [1,2,3,4,5] => w5InArray(var, [1,2,3,4,5]) < 0
										let reg = new RegExp(/(\w+) not in (\[[',0-9\s\w]+\])/gi)

										// проверяем
										if (reg.exec(_expr) !== null)
										{
											_expr = _expr.replace(reg, 'w5InArray($1, $2) < 0')
										}
										else
										{
											// var[idx] not in [1,2,3,4,5] => w5InArray(var__idx__, [1,2,3,4,5]) < 0
											reg = new RegExp(/(\w+\[\w+\]) not in (\[[',\w\s]+\])/i)
											let _mtch = null
											if ((_mtch = reg.exec(_expr)) !== null)
											{
												_expr = _expr.replace(_mtch[0], 'w5InArray(' +
													_mtch[1].replace(/\[/g, '__').replace(/]/g, '__') +
													', ' +
													_mtch[2] +
													') < 0')
											}
										}
									}
									// условие: var in [array]
									else
									{
										// var in [1,2,3,4,5] => w5InArray(var, [1,2,3,4,5])
										let reg = new RegExp(/(\w+) in (\[[',0-9\s\w]+\])/gi)

										// проверяем
										if (reg.exec(_expr) !== null)
										{
											_expr = _expr.replace(reg, 'w5InArray($1, $2) !== -1')
										}
										else
										{
											// var[idx] in [1,2,3,4,5] => w5InArray(var__idx__, [1,2,3,4,5])
											reg = new RegExp(/(\w+\[\w+\]) in (\[[',\w\s]+\])/i)
											let _mtch = null
											if ((_mtch = reg.exec(_expr)) !== null)
											{
												_expr = _expr.replace(_mtch[0], 'w5InArray(' +
													_mtch[1].replace(/\[/g, '__').replace(/]/g, '__') +
													', ' +
													_mtch[2] +
													') !== -1')
											}
										}
									}
								}
								// type[period] == 0    =>    type__period__ == 0
								else _expr = _expr.replace(/\[/g, '__').replace(/]/g, '__')
								_expressions[field['_field_name']] = _expr
							}
						}
					})
				}
			})

			// теперь бежим по всем полученным выражениям
			for (let e in _expressions)
			{
				// подменяем поля на свойства объекта
				let _exp = _expressions[e]
				for (let v in _values)
				{
					let reg = new RegExp('\\b' + v + '\\b', 'gi')
					_exp = _exp.replace(reg, (str, offset, src) => {
						// если в начале строки - это точно поле
						if (offset <= 0) return 'obj.' + v
						// если не в начале, и сразу перед ним стоит кавычка - это точно не поле
						else if (src.charAt(offset - 1) === '\'' || src.charAt(offset - 1) === '"') return v
						// по умолчанию это все таки поле
						return 'obj.' + v
					})
				}

				// формируем функцию
				// eslint-disable-next-line
				let _func = new Function('obj', ' return ' + _exp)

				// ищем поле
				let _field = this.findField(e)
				if (_field)
				{
					// обнулим ошибку в любом случае
					this.$set(_field, '_errMsg', '')
					// установим видимость поля
					this.$set(_field, '_visible', _func(_values))
				}
			}
		},
		//---------------------------------------------------------------------
		// дополнительная установка значений в числовые поля и поля-даты
		// из-за используемых дополнительных сторонних плагинов
		//---------------------------------------------------------------------
		fillNumberFields() {
			// бежим по всем полям
			let _rows = this.formData['fields']
			if (!_rows || !Array.isArray(_rows)) return

			// бежим по всем полям - собираем значения и выражения
			_rows.forEach((item) => {
				// смотрим только строки которые определены и являются массивами
				if (item && Array.isArray(item))
				{
					item.forEach((field, idx, arr) => {
						// смотрим поля с названиями и числовым типом
						if (field['_field_name'] &&
							(field['type'] === 'int' || field['type'] === 'integer' || field['type'] === 'money' || field['type'] === 'float') &&
							field['value'] !== undefined && field['value'] !== null)
						{
							EventBus.$emit('w5-set-money-field-value', {
								'type': field['type'],
								'name': field['_field_name'],
								'value': field['value']
							})
						}
						// смотрим поля с названиями и типом Date
						else if (field['_field_name'] && field['type'] === 'date' &&
							field['value'] !== undefined && field['value'] !== null && String(field['value']).trim() !== '')
						{
							EventBus.$emit('w5-set-date-field-value', {
								'name': field['_field_name'],
								'value': field['value']
							})
						}
					})
				}
			})
		},
		//---------------------------------------------------------------------
		// установка текста локального сообщения об успехе с таймером
		//---------------------------------------------------------------------
		setLocalSuccessMessage(msg) {
			EventBus.$emit('w5-notificator-add', {
				'title': ' ',
				'message': msg,
				'class': 'success',
				'type': 'nourl',
				'id': 'success-message',
				'timeout': 3000
			})
		},
		//---------------------------------------------------------------------
		// преобразование списка шаблонов для VDS
		//---------------------------------------------------------------------
		prepareTemplateList(field) {
			Helper.prepareTemplateList(field)
		},
		//---------------------------------------------------------------------
		// закрытие диалога пополнения баланса
		//---------------------------------------------------------------------
		hideMoneyModal() {
			EventBus.$emit('w5-body-scroll-enable')
			this.showMoneyModal = false
			this.hideModalMask()
		},
		// переход в форму пополнения денег
		goToMoney() {
			// закрываем форму
			this.hideMoneyModal()
			// ставим признак для роутера - что это сабмит формы
			this.isFormSubmited = true
			// переходим в форму пополнения
			this.$router.push('/operation/create')
		},
		// продолжение
		continueSubmit() {
			// для начала закрываем диалог
			this.hideMoneyModal()
			// просто ставим флаг и снова сабмитим форму
			this.moneyModalAddButton = 'continue'
			this.submitForm()
		},
		//---------------------------------------------------------------------
		// диалог создания плательщика
		//---------------------------------------------------------------------
		hidePayerDialogModal() {
			EventBus.$emit('w5-body-scroll-enable')
			this.showPayerDialogModal = false
			this.hideModalMask()
		},
		// переход в форму создания плательщика
		goToCreatePayer() {
			// закрываем форму
			this.hidePayerDialogModal()
			// переходим в форму создания
			this.$router.push('/payer/create')
		},
		// показываем диалог по событию
		showPayerDialog() {
			EventBus.$emit('w5-body-scroll-disable')
			this.showPayerDialogModal = true
		},
		//---------------------------------------------------------------------
		// освободили порт
		//---------------------------------------------------------------------
		onFreePort(fromField) {
			let from = this.findField(fromField)
			if (from) from.__isPortActive = false
		},
		//---------------------------------------------------------------------
		// диалог удаления
		//---------------------------------------------------------------------
		// клиент удаляет сохраненный способ оплаты
		onDeleteSavedPayment(id) {
			if (!id) return

			if (this.deleteModalTimerHandler) clearInterval(this.deleteModalTimerHandler)
			this.deleteModalTimer = 5
			this.deleteModalText = ''
			this.deleteButtonTitle = this.localeFtc('main/delete_timer').replace('{count}', this.deleteModalTimer)

			// ищем поле
			let _savedIdField = this.findField('saved')
			if (!_savedIdField || typeof _savedIdField !== 'object' || !_savedIdField.list || !_savedIdField.list.length) return

			// запомним ID
			this.deleteModalValue = id

			// текст диалога
			let showValue = id
			_savedIdField.list.some(item => {
				if (item && item.id === showValue)
				{
					showValue = item.name
					return true
				}
			})
			this.deleteModalText = this.localeFtc('main/delete_msg').replace('{name}', showValue)

			EventBus.$emit('w5-body-scroll-disable')
			this.showDeleteModal = true

			this.deleteModalTimerHandler = setInterval(() => {
				this.deleteModalTimer--
				this.deleteButtonTitle = this.localeFtc('main/delete_timer').replace('{count}', this.deleteModalTimer)

				if (this.deleteModalTimer <= 0)
				{
					this.deleteButtonTitle = this.localeFtc('main/delete')
					clearInterval(this.deleteModalTimerHandler)
					this.deleteModalTimerHandler = null
				}
			}, 1000)
		},
		// закрыть диалог
		hideDeleteModal() {
			EventBus.$emit('w5-body-scroll-enable')
			this.showDeleteModal = false
			this.hideModalMask()
		},
		// клик по кнопке диалога - подтверждение
		deleteModalCallback() {
			// если таймер еще не закончился
			if (this.deleteModalTimer > 0) return

			// если не задан ID
			if (this.deleteModalValue === undefined || this.deleteModalValue === null || this.deleteModalValue <= 0) return

			// обнуляем значения
			this.localErrorMessage = ''

			// закрыть диалог
			this.hideDeleteModal()

			// ищем поле
			let _savedIdField = this.findField('saved')
			if (!_savedIdField || typeof _savedIdField !== 'object' || !_savedIdField.list || !_savedIdField.list.length)
			{
				this.localErrorMessage = 'error/required_field'
				return
			}

			// все в порядке - формируем URL
			let _url = this.APIServerUrl + '/operation/delete?additional=setDeleteSaved&saved_id=' + this.deleteModalValue
			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'])
					{
						// готовим данные POST
						let _post = { '_csrf': _dt['_csrf'] }
						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									let msg = 'payment/deleted'
									if (_dt['title']) msg = _dt['title']
									// покадем сообщение об успехе
									EventBus.$emit('w5-notificator-add', {
										'title': ' ',
										'message': msg,
										'class': 'success',
										'type': 'nourl',
										'id': 'success-message',
										'timeout': 3000
									})
									// удалим из списка локально
									if (_savedIdField.list && _savedIdField.list.length)
									{
										_savedIdField.list.some((item, idx) => {
											if (item && item.id === this.deleteModalValue)
											{
												_savedIdField.list.splice(idx, 1)
												return true
											}
										})

										// если при этом больше нет сохраненных способов - нужно скрыть и хеадер
										this.hideHeaderFieldForSavedPayments()
									}
									// на это все
									return
								}

								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						// на этом все
						return
					}

					// ошибка формата ответа
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		// найти и скрыт хэдер для сохраненных платежей
		hideHeaderFieldForSavedPayments() {
			// если нет вообще полей
			if (!this.formData.fields || !this.formData.fields.length) return

			// поля есть - пробежимся по ним в обратном порядке
			let _len = this.formData.fields.length
			let seek = false
			let found = false
			for (let i = _len - 1; i >= 0; i--)
			{
				let row = this.formData.fields[i]
				if (row && Array.isArray(row))
				{
					// если поле с сохраненными способами еще не найден
					if (!seek)
					{
						// ищем поле
						row.some(obj => {
							if (obj && obj['_field_name'] === 'saved')
							{
								// ставим флаг что нашли
								seek = true
								return true
							}
						})
					}
					// если поле уже найдено - можем искать поле с заголовком
					else
					{
						row.some(obj => {
							if (obj && obj['type'] === 'header')
							{
								obj._visible = false
								found = true
								return true
							}
						})

						if (found) break
					}
				}
			}
		},
		//---------------------------------------------------------------------
		// диалог 2FA
		//---------------------------------------------------------------------
		hide2FADialogModal() {
			EventBus.$emit('w5-body-scroll-enable')
			this.show2FADialogModal = false
			this.hideModalMask()
		},
		// показываем диалог по событию
		show2FADialog() {
			EventBus.$emit('w5-body-scroll-disable')
			this.show2FADialogModal = true
		},
		// поиск полей формы 2FA
		find2FAField(name) {
			// бежим по всем полям
			let _rows = this.fields2FA.fields
			if (!_rows || !Array.isArray(_rows)) return null

			// поля есть - пробежимся по ним
			let _field = null
			_rows.some(item => {
				if (item && Array.isArray(item))
				{
					item.some(obj => {
						if (obj && obj['_field_name'] === name)
						{
							_field = obj
							return true
						}
					})

					if (_field) return true
				}
			})

			return _field
		},
		// сабмит формы
		submit2FAForm() {
			// проверим поле с кодом
			let _field = this.find2FAField('code')
			if (!_field) return
			if (!_field.value)
			{
				_field['_errMsg'] = 'error/required_field'
				return
			}

			// обнулим сообщения
			this.localErrorMessage = ''

			// проверим - есть ли поля с ошибками
			let _isErr = this.fields2FA.fields.some(row => {
				let _found = false
				if (row && Array.isArray(row) && row.length)
				{
					_found = row.some(fld => {
						if (!fld['_visible']) return false
						// обязательное поле?
						if (fld['required'] === true)
						{
							// если значение вообще не задано
							if (fld.value === undefined || fld.value === null)
							{
								fld['_errMsg'] = 'error/required_field'
								return true
							}
						}
					})
				}

				if (_found) return true
			})
			if (_isErr) return

			// все в порядке - делаем запрос
			// формируем URL
			let _url = this.APIServerUrl + '/twofa/create'
			if (this.fields2FA.__value === true)
				_url = this.APIServerUrl + '/twofa/delete'
			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form')
					{
						// формируем POST-параметры
						let _post = { '_csrf': _dt['_csrf'] }
						_post[_dt['model']] = {}
						// соберем значения всех полей
						this.fields2FA.fields.forEach(row => {
							if (row && Array.isArray(row) && row.length)
							{
								row.forEach(fld => {
									let _value = fld['value']
									if (fld['type'] === 'boolean')
									{
										_value = Helper.normalizeBooleanValue(fld['value']) ? 1 : 0
									}
									_post[_dt['model']][fld['_field_name']] = _value
								})
							}
						})
						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// успешное сообщение
									let _msg = this.fields2FA.__value ? 'twofa/deleted' : 'twofa/created'
									if (_dt['title']) _msg = _dt['title']
									this.setLocalSuccessMessage(_msg)
									// заменим поле
									let _field = this.findField('twofa')
									if (_field)
									{
										_field['value'] = !this.fields2FA.__value
										// что бы не переспрашивал
										_field['_oldValue'] = _field['value']
									}
									// закроме диалог
									this.hide2FADialogModal()
									// на этом все
									return
								}

								// если указана какая то ошибка
								if (_dt && _dt['status'] === 'error' && _dt['fields'] && typeof _dt['fields'] === 'object')
								{
									// бежим по всем полям
									for (let f in _dt['fields']) if (_dt['fields'].hasOwnProperty(f))
									{
										// сразу ищме поле
										let _fld = this.find2FAField(f)
										if (_fld)
										{
											// сообщение по умолчанию
											_fld['_errMsg'] = this.localeFtc('main/error_desc').replace(':', '')
											EventBus.$emit('w5-set-field-error')
											// если пришел массив - берем первое сообщение
											if (Array.isArray(_dt['fields'][f]))
											{
												if (_dt['fields'][f].length)
													_fld['_errMsg'] = this.localeFtc(_dt['fields'][f][0])
											}
											else _fld['_errMsg'] = this.localeFtc(_dt['fields'][f])
										}
									}

									return
								}

								// закроме диалог
								this.hide2FADialogModal()
								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// закроме диалог
								this.hide2FADialogModal()
								// ошибка сервера
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						// на этом все
						return
					}

					// закроме диалог
					this.hide2FADialogModal()
					// ошибка формата ответа
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					// закроме диалог
					this.hide2FADialogModal()
					// ошибка сервера
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		// запрос на смену значения
		on2FAValue(curValue) {
			this.localErrorMessage = ''

			// пытаются включить 2FA
			if (!curValue)
			{
				this.$http.get(Vue.APIServerUrl + '/twofa/create')
				.then(res => {
					// получаем ответ
					let _dt = res && res.data && typeof res.data === 'object' ? res.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form')
					{
						this.fields2FA = this.parseFormData(_dt)
						// запоминаем флаг
						this.fields2FA.__value = curValue
						// просто показываем диалог
						this.show2FADialog()
						return
					}

					throw res
				})
				.catch(err => {
					let _msg = 'register/error'
					if (err) _msg = this.formatRequestError(err)
					this.localErrorMessage = _msg
				})
			}
			// пытаются выключить 2FA
			else
			{
				this.$http.get(Vue.APIServerUrl + '/twofa/delete')
				.then(res => {
					// получаем ответ
					let _dt = res && res.data && typeof res.data === 'object' ? res.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form')
					{
						this.fields2FA = this.parseFormData(_dt)
						// запоминаем флаг
						this.fields2FA.__value = curValue
						// просто показываем диалог
						this.show2FADialog()
						return
					}

					throw res
				})
				.catch(err => {
					let _msg = 'register/error'
					if (err) _msg = this.formatRequestError(err)
					this.localErrorMessage = _msg
				})
			}
		},
		//---------------------------------------------------------------------
		// клиент запросил создание оплаты для пополнения баланса
		// с определенным способом оплаты
		//---------------------------------------------------------------------
		onClientCreateOperation(id) {
			// сабмитим форму со следующим шагом
			this.submitForm('nextStep')
		},
		//---------------------------------------------------------------------
		// клиент пытается сделать платежку юр.лица
		//---------------------------------------------------------------------
		bankLegalPaySubmit(id) {
			// ищем поле с плательщиком
			let _payerField = this.findField('payer')

			// если это поле видимо и оно пустое
			if (_payerField && _payerField._visible && (!_payerField.list || !_payerField.list.length))
			{
				EventBus.$emit('w5-show-payer-dialog')
				return
			}

			// если это поле видимо и выбрано какое то значение - только
			// в этом случае идет на следующий шаг
			if (_payerField && _payerField._visible &&
				_payerField.value !== undefined && _payerField.value !== null && _payerField.value !== '')
			{
				//this.submitForm('nextStep')
			}
			else
			{
				// а иначе делаем изменение значения поля способа оплаты
				let _payField = this.findField('payment')
				_payField.value = parseInt(id)
				this.fieldChanged(_payField)
			}
		},
		//---------------------------------------------------------------------
		// диалог выбора шаблона ответа для тикета
		//---------------------------------------------------------------------
		// показать диалог
		showTemplateDialog() {
			// только для тикетов
			if (this.crud !== 'ticket' && this.crud !== 'ticketmessage') return
			// обнуляем ошибку
			this.localErrorMessage = ''
			// определим тип тикета
			let _type = 'mails'
			let _typeField = this.findField('type')
			if (_typeField && _typeField['value'] === 'notice') _type = 'notice'
			// в зависимости от типа ставим заголовок поля
			this.$set(this.templateField, 'title', _type === 'notice' ? 'notes/templates' : 'mails/templates')
			// ставим URL поиска
			this.$set(this.templateField, 'url', '/text/list?search=template&category=' + _type + '&q=')
			// показываем диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showTemplateModal = true
			// фокус на поле в следующем тике
			this.$nextTick(() => {
				if (this.$refs &&
					this.$refs['textSearchTemplateDialog'] &&
					this.$refs['textSearchTemplateDialog'].$el &&
					this.$refs['textSearchTemplateDialog'].$el.querySelector('input'))
					this.$refs['textSearchTemplateDialog'].$el.querySelector('input').focus()
			})
		},
		// скрыть диалог
		hideTemplateModal() {
			EventBus.$emit('w5-click-on-modal')
			EventBus.$emit('w5-body-scroll-enable')
			this.showTemplateModal = false
			this.hideModalMask()
		},
		// выбрали шаблон
		templateChoiced(text) {
			// сразу закрываем даилог
			this.hideTemplateModal()
			// только для тикетов
			if (this.crud !== 'ticket' && this.crud !== 'ticketmessage') return
			// если значение так и не выбрали
			if (text === undefined || text === null || text === '') return

			// найдем поле в DOM
			let _textarea = $('textarea[name="content"]:first')
			if (!_textarea || !_textarea.length) return

			// получим положение курсора
			let _cursorPosition = _textarea.prop('selectionStart')

			// вставим текст в положение курсора
			this.insertTextAtCursor(_textarea[0], '\n' + text)

			// обновим модель
			let _field = this.findField('content')
			if (!_field) return
			this.$set(_field, 'value', _textarea.val())
			this.fieldChanged(_field)

			// перейдем на форму
			this.$nextTick(() => {
				_textarea.setCursorPosition(_cursorPosition)
				_textarea.focus()
			})
		},
		//---------------------------------------------------------------------
		// вставка текста в элемент DOM
		//---------------------------------------------------------------------
		insertTextAtCursor(el, text, offset = 0) {
			let val = el.value
			let endIndex
			let range
			let doc = el.ownerDocument

			if (typeof el.selectionStart === 'number' && typeof el.selectionEnd === 'number')
			{
				endIndex = el.selectionEnd
				el.value = val.slice(0, endIndex) + text + val.slice(endIndex)
				el.selectionStart = el.selectionEnd = endIndex + text.length + offset
			}
			else if (doc.selection !== 'undefined' && doc.selection.createRange)
			{
				el.focus()
				range = doc.selection.createRange()
				range.collapse(false)
				range.text = text
				range.select()
			}
		},
		//---------------------------------------------------------------------
		// обработчик кликов, которы если кликнули по модальному контейнеру
		// останавливает действие
		//---------------------------------------------------------------------
		filterModalContainers(e) {
			if (!e || !e.target || !e.target.className) return
			if (e.target.className.indexOf('modal') > -1 || e.target.className === 'input-text')
			{
				EventBus.$emit('w5-click-on-modal')
				e.preventDefault()
				e.stopPropagation()
				e.stopImmediatePropagation()
				return
			}

			if (!e.target.parentNode || !e.target.parentNode.className) return
			if (e.target.parentNode.className.indexOf('modal') > -1 || e.target.className === 'input-text')
			{
				EventBus.$emit('w5-click-on-modal')
				e.preventDefault()
				e.stopPropagation()
				e.stopImmediatePropagation()
				return
			}
		},
		//---------------------------------------------------------------------
		// создание ssh-ключа
		//---------------------------------------------------------------------
		// закрытие диалога конвертации
		hideSshKeyModal() {
			EventBus.$emit('w5-body-scroll-enable')
			this.showSshKeyModal = false
			this.hideModalMask()
		},
		// уход фокуса с поля формы
		onBlurSshKey(field) {
			// проверка значения поля
			this.verifyFieldSshKey(field)
		},
		// фокус не поле формы
		onFocusSshKey(field) {
			if (field) field['_errMsg'] = ''
		},
		// нажали ENTER на поле формы конвертации
		onEnterKeyDownSshKey() {
			this.sshKeyCreateBegin()
		},
		// проверка значения поля !!!!!
		verifyFieldSshKey(field) {
		},
		// видимость строки
		isVisibleSshKeyField(row) {
			// проверка данных
			if (!row || !Array.isArray(row) || !row.length) return false
			// по умолчанию не видна
			let _answer = false
			// ищем любое поле с типом не "hidden"
			row.some((item, idx, arr) => {
				// если такое поле есть - значит строка должна быть видима
				if (item && item.type !== 'hidden')
				{
					_answer = true
					return true
				}
			})

			// возвращаем результат
			return _answer
		},
		// поиск поля
		findSshKeyField(name) {
			// бежим по всем полям
			let _rows = this.sshKeyFields.fields
			if (!_rows || !Array.isArray(_rows)) return

			// поля есть - пробежимся по ним
			let _field = null
			_rows.some(item => {
				if (item && Array.isArray(item))
				{
					item.some(obj => {
						if (obj && obj['_field_name'] === name)
						{
							_field = obj
							return true
						}
					})

					if (_field) return true
				}
			})

			return _field
		},
		// подтвердили создание ключа
		sshKeyCreateBegin() {
			// проверим как минимум два поля
			// 1. наименование
			let _field = this.findSshKeyField('name')
			if (!_field) return
			if (!_field.value)
			{
				_field['_errMsg'] = 'error/required_field'
				return
			}
			let _keyName = _field.value
			// 2. содержание
			_field = this.findSshKeyField('data')
			if (!_field) return
			if (!_field.value)
			{
				_field['_errMsg'] = 'error/required_field'
				return
			}

			// обнулим сообщения
			this.localErrorMessage = ''
			// проверим - есть ли поля с ошибками
			let _isErr = this.sshKeyFields.fields.some(row => {
				let _found = false
				if (row && Array.isArray(row) && row.length)
				{
					_found = row.some(fld => {
						if (!fld['_visible']) return false
						// обязательное поле?
						if (fld['required'] === true)
						{
							// если значение вообще не задано
							if (fld.value === undefined || fld.value === null)
							{
								fld['_errMsg'] = 'error/required_field'
								return true
							}
						}
					})
				}

				if (_found) return true
			})
			if (_isErr) return

			// все в порядке - делаем запрос
			// формируем URL
			let _url = this.APIServerUrl + '/sshkey/create'
			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form')
					{
						// формируем POST-параметры
						let _post = { '_csrf': _dt['_csrf'] }
						_post[_dt['model']] = {}
						// соберем значения всех полей
						this.sshKeyFields.fields.forEach(row => {
							if (row && Array.isArray(row) && row.length)
							{
								row.forEach(fld => {
									let _value = fld['value']
									if (fld['type'] === 'boolean')
									{
										_value = Helper.normalizeBooleanValue(fld['value']) ? 1 : 0
									}
									_post[_dt['model']][fld['_field_name']] = _value
								})
							}
						})
						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok' && _dt['sshkey'] && _dt['sshkey']['key_id'])
								{
									// успешное сообщение
									this.setLocalSuccessMessage('sshkey/created')
									// заменим поле
									let _field = this.findField('sshkey_id')
									if (_field)
									{
										_field.type = 'list'
										delete _field.buttonFunction
										delete _field.buttonText

										// ищем в списке - есть ли уже пустое значение
										let _found = _field['list'].some(obj => (obj && String(obj.id) === '-1000'))

										// добавим возможность выбора пустого значения
										if (!_found)
										{
											_field['list'].push({
												//'id': 'emptyValue',
												'id': -1000,
												'name': this.localeFtc('sshkey/not_use')
											})
										}

										// добавим только что созданный ключ
										_field['list'].push({
											'id': _dt['sshkey']['key_id'],
											'name': _keyName
										})

										// установим его в значение
										_field['value'] = String(_dt['sshkey']['key_id'])
									}
									else this.requestData()
									// закроме диалог
									this.hideSshKeyModal()
									// на этом все
									return
								}

								// если указана какая то ошибка
								if (_dt && _dt['status'] === 'error' && _dt['fields'] && typeof _dt['fields'] === 'object')
								{
									// бежим по всем полям
									for (let f in _dt['fields']) if (_dt['fields'].hasOwnProperty(f))
									{
										// сразу ищме поле
										let _fld = this.findSshKeyField(f)
										if (_fld)
										{
											// сообщение по умолчанию
											_fld['_errMsg'] = this.localeFtc('main/error_desc').replace(':', '')
											EventBus.$emit('w5-set-field-error')
											// если пришел массив - берем первое сообщение
											if (Array.isArray(_dt['fields'][f]))
											{
												if (_dt['fields'][f].length)
													_fld['_errMsg'] = this.localeFtc(_dt['fields'][f][0])
											}
											else _fld['_errMsg'] = this.localeFtc(_dt['fields'][f])
										}
									}

									return
								}

								// закроме диалог
								this.hideSshKeyModal()
								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// закроме диалог
								this.hideSshKeyModal()
								// ошибка сервера
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						// на этом все
						return
					}

					// закроме диалог
					this.hideSshKeyModal()
					// ошибка формата ответа
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					// закроме диалог
					this.hideSshKeyModal()
					// ошибка сервера
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// сборс настроек текущего пользователя
		//---------------------------------------------------------------------
		clearSettingsStart() {
			// чистим настройки пользователя на АПИ-сервере
			this.$store.commit('clearUserOptionsOnServer')

			// чистим настройки пользователя в localStorage
			// только свои настройки
			let _reg = new RegExp('^w5_' + this.$store.state.user_id, 'i')
			let _keys = []
			// ищем в LocalStorage
			for (let i = 0; i < localStorage.length; i++)
			{
				// текущий ключ
				let _key = localStorage.key(i)
				// это наша настройка или процесс клонирования
				if (_reg.test(_key) || String(_key).indexOf('vds_clone_process_') === 0) {
					_keys.push(_key)
				}
			}
			// теперь удалим что нашли
			_keys.forEach(k => {
				localStorage.removeItem(k)
			})

			// чистим настройки пользователя в sessionStorage
			_keys = []
			// ищем в sessionStorage
			for (let i = 0; i < sessionStorage.length; i++)
			{
				// текущий ключ
				let _key = sessionStorage.key(i)
				// это наша настройка
				if (_reg.test(_key)) _keys.push(_key)
			}
			// теперь удалим что нашли
			_keys.forEach(k => {
				sessionStorage.removeItem(k)
			})

			// сброс флага
			this.clearSettings = false
		},
		//---------------------------------------------------------------------
		// событие: блокировка всего приложения
		//---------------------------------------------------------------------
		blockApplicationHandler() {
			// если недоступен sessionStorage - ничего не делаем
			if (!window.sessionStorage) return
			// если нет измененных полей - ничего не делаем
			if (!Helper.isFormChanged(this.formData, this.crud, this.action, this.$store)) return
			// сохраним данные формы
			let _key = 'formSaver_' + this.$route.path.replace(/\//g, '_')
			window.sessionStorage.setItem(_key, JSON.stringify(this.formData))
		},
		//---------------------------------------------------------------------
		// конвертация данных в FormData
		//---------------------------------------------------------------------
		FD_prepare: function(d, key) {
			let k

			for (k in d) if (d.hasOwnProperty(k))
			{
				// если пересылают файл в форме - патч для safari 10+
				if (d[k] && key &&
					k === 'file' &&
					typeof d[k] === 'object' &&
					'name' in d[k] &&
					'size' in d[k] &&
					'type' in d[k])
				{
					this.FD.append(key + '[' + k + ']', d[k])
					this.FD_count++
					continue
				}

				// остальные поля обрабатываем по старому
				if (typeof d[k] === 'object' && d[k] && !('lastModifiedDate' in d[k]))
				{
					if (key)
					{
						this.FD_prepare(d[k], key + '[' + k + ']')
					}
					else
					{
						this.FD_prepare(d[k], k)
					}
				}
				else
				{
					if (key)
					{
						this.FD.append(key + '[' + k + ']', d[k])
					}
					else
					{
						this.FD.append(k, d[k])
					}

					this.FD_count++
				}
			}
		},
		//---------------------------------------------------------------------
		// сбор данных для формы
		//---------------------------------------------------------------------
		collectData(rows) {
			// обнуляем данные
			let data = {}

			// смотрим каждое поле простым циклом - что бы прервать его в любой момент
			for (let idx in rows)
			{
				// если нет значения - пропускаем
				if (!rows[idx] || !Array.isArray(rows[idx])) continue

				// бежим по всей строке формы
				let row = rows[idx]
				for (let k in row)
				{
					// получим объект - поле
					let field = row[k]

					// рассматриваем только поля с наименованиями
					if (!field['_field_name']) continue

					// поля с флагом fake - пропускаем
					if (field['fake'] === true) continue

					// если есть хотя бы одно видимое поле с ошибкой - прерываем
					if (field['_errMsg'] && field['_visible'])
					{
						this.buttonBlock = 0
						return false
					}

					// значение по умолчанию
					let _val = field['value']

					// если это "file" или "image"
					if (field['type'] === 'file' || field['type'] === 'image')
					{
						// если есть метка удаления файла
						if (field['_deleteFile'] === true)
						{
							// добавляем еще параметр
							data[field['_field_name'] + '_delete'] = 1
						}

						// если это одиночное значение
						if (field['multifile'] !== true)
						{
							// если задан URl - значит ничего нового не задавали, не нужно пересылать это
							if (_val && (_val.indexOf('.') > -1 || _val.indexOf('/') > -1)) _val = null
						}
					}

					// если это массив
					if (Array.isArray(field['value']))
					{
						// если это пустой массив
						if (!field['value'].length) _val = null
						else
						{
							// масив имеет значения
							_val = []
							// бежим по нему, для конвертации
							field['value'].forEach(item => {
								// если элемент массива - это объект c id
								if (typeof item === 'object' && item['id'])
								{
									_val.push(item['id'])
								}
								// если простой тип
								else _val.push(item)
							})
						}
					}

					// обязательное поле?
					if (field['required'] === true && field['_visible'])
					{
						// если значение вообще не задано
						if (_val === undefined || _val === null)
						{
							field['_errMsg'] = 'error/required_field'
							this.buttonBlock = 0
							return false
						}

						// если это пустой массив
						if (Array.isArray(_val) && _val.length === 0)
						{
							field['_errMsg'] = 'error/required_field'
							this.buttonBlock = 0
							return false
						}
					}

					// локальная проверка
					if (!this.localValidation(field))
					{
						// сообщение уже записано
						this.buttonBlock = 0
						return false
					}

					// если пустые поля
					if (_val === undefined || _val === null)
					{
						// частный случай
						if (this.crud === 'rackdevice' && field['type'] === 'boolean')
						{
							// всегда передаем
							data[field['_field_name']] = 0
							continue
						}

						// если это поле массива - все равно передаем
						if (/^\w+\[\w+\]/i.test(field['_field_name']))
							data[field['_field_name']] = ''
						// остальное игнорируем
						continue
					}

					// частный случай
					if (parseInt(_val, 10) === -1000 &&
						(field['_field_name'] === 'sshkey_id' || field['_field_name'] === 'reserve_ip'))
					{
						// пропускаем значение
						continue
					}

					// конвертация значения
					if (field['type'] === 'boolean')
						_val = Helper.normalizeBooleanValue(_val) ? 1 : 0

					// если это номер телефона
					if (field['type'] === 'text' && (field['_field_name'].indexOf('phone') > -1 || field['_field_name'].indexOf('[fax]') > -1))
					{
						// если стоит валидатор "phone"
						if (field['validator'] === 'phone')
						{
							// отправляем с форматированием
							// удалим остатки маски
							_val = String(_val).replace(/_/g, '')
							// есть ли в значении круглые скобки
							if (_val.indexOf('(') > -1 || _val.indexOf(')') > -1)
							{
								// собираем значение
								_val = _val.replace(/\(/g, ' ').replace(/\)/g, ' ').replace(/-/g, '')
							}
							else
							{
								// если нет скобок - просто заменяем первые два прочерка на пробелы
								_val = _val.replace('-', ' ')
								_val = _val.replace('-', ' ')
								// а остальные просто убираем
								_val = _val.replace(/-/g, '')
							}
						}
						else
						{
							// а иначе просто убираем лишние символы
							_val = String(_val).replace(/[()\s]/g, '')
						}
					}

					// если это дата с заданным форматом
					if (field['type'] === 'date' && field['format'])
					{
						// требуется преобразование
						_val = String(_val)
						if (/^\d{4}-\d{2}-\d{2}$/.test(_val) || /^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}$/.test(_val))
							_val = Helper.FormatDateTime(_val, field['format'])
					}

					// если это группа и оно имеет множественное значение
					if (field['_field_name'] === 'plan_group_id' &&
						field['type'] === 'list' &&
						!field['multiselect'] &&
						field['value'] && Array.isArray(field['value']) && field['value'].length)
					{
						// ищем поле с тарифом
						let planField = this.findField('plan_id')
						if (!planField ||
							!planField.list ||
							!planField.list.length ||
							!planField.value)
						{
							field['_errMsg'] = 'error/required_field'
							this.buttonBlock = 0
							return false
						}

						// ищем в группу тарифа
						_val = null
						planField.list.some(plan => {
							if (String(plan.id) === String(planField.value))
							{
								_val = plan.group
								return true
							}
						})
						// если так и не нашли
						if (!_val)
						{
							field['_errMsg'] = 'error/required_field'
							this.buttonBlock = 0
							return false
						}
					}

					// частный случай если это создание внешнего диска
					if (this.crud === 'disks')
					{
						// если поле "options" не включено - не передаем его
						if (field['_field_name'] === 'options' && !field['required'] && !_val)
						{
							continue
						}
						if (!field['_visible'] && !field['required'])
						{
							continue
						}
					}

					// все проверки пройдены - запоминаем значение
					data[field['_field_name']] = _val

					// если это создание VDS и тариф с параметром
					if (this.crud === 'vds' && field['_field_name'] === 'plan_id')
					{
						// ищем поле с тарифом
						if (!field.list ||
							!field.list.length ||
							!field.value)
						{
							field['_errMsg'] = 'error/required_field'
							this.buttonBlock = 0
							return false
						}

						// ищем в сам тариф
						let _plan = null
						field.list.some(plan => {
							if (String(plan.id) === String(field.value))
							{
								_plan = Object.assign({}, plan)
								return true
							}
						})

						// если так и не нашли
						if (!_plan)
						{
							field['_errMsg'] = 'error/required_field'
							this.buttonBlock = 0
							return false
						}

						// если это поле с параметрами
						if (_plan.has_params && _plan.params && this.params)
						{
							for (let p in this.params)
							{
								data[p] = this.params[p]
							}
						}
					}
				}
			}

			// возвращаем полученный ответ
			return data
		},
		//---------------------------------------------------------------------
		// NameForm[data[disk]] => NameForm[data][disk]
		//---------------------------------------------------------------------
		FD_rePack(data) {
			let k
			let n1
			let n2
			let key1
			let key2

			for (k in data) if (data.hasOwnProperty(k))
			{
				n1 = k.indexOf('[')
				if (n1 < 0) continue

				n2 = k.indexOf(']', n1)
				if (n2 < 0) continue

				key1 = k.substr(0, n1)
				key2 = k.substring(n1 + 1, n2)

				if (n2 + 1 < k.length) key2 += k.substr(n2 + 1)

				if (!data[key1]) data[key1] = {}

				data[key1][key2] = data[k]

				delete data[k]

				data[key1] = this.FD_rePack(data[key1])
			}

			return data
		},
		//---------------------------------------------------------------------
		// изменяют URL внутри приложения
		//---------------------------------------------------------------------
		onBeforePopState() {
			// если это сабмит формы - все ОК
			if (this.isFormSubmited) return true
			// так как на логаут два раза запрос идет - пользователь
			// может быть уже неавторизован
			if (!this.$store.state.is_auth) return true

			// если запущен процесс инициализации начальных значений
			if (this.$store.state.isInitFormsValue > 0) return true

			// если показан диалог блокировки всего приложения
			if (this.$store.state.applicationBlocked)
			{
				return false
			}

			// смотрим - есть ли измененные данные в какой то форме
			if (Helper.isFormChanged(this.formData, this.crud, this.action, this.$store) || this.isConstructPlanChanged)
			{
				// да, есть измененные поля - нужно переспросить
				// строим сообщение вопроса по умолчанию
				let _question = 'application/leave_page_confirm'
				// если есть активные загрузки файлов
				if (this.$store.state.uploadFileCounter > 0)
					_question = this.$store.state.uploadFileCounter === 1 ? 'Идет загрузка файла, превать?' : 'Идет загрузка файлов, превать?'
				// спрашиваем
				if (confirm(this.localeFtc(_question)))
				{
					return true
				}
				else
				{
					// отмена действия
					return false
				}
			}

			return true
		},
		//---------------------------------------------------------------------
		// закрывают вкладку или делают рефреш
		//---------------------------------------------------------------------
		onBeforeUnload() {
			// смотрим - есть ли измененные данные в какой то форме
			// при этом, если приложение блокировано - ничего не нужно спрашивать
			if (
				(Helper.isFormChanged(this.formData, this.crud, this.action, this.$store) || this.isConstructPlanChanged) &&
				!this.$store.state.applicationBlocked
			)
			{
				// если есть активные загрузки файлов
				if (this.$store.state.uploadFileCounter > 0)
					return this.$store.state.uploadFileCounter === 1 ? 'Идет загрузка файла, превать?' : 'Идет загрузка файлов, превать?'
				// сообщение по умолчанию
				return 'Возможно, внесенные изменения не сохранятся.'
			}
		},
		//---------------------------------------------------------------------
		// получение текущей группы
		//---------------------------------------------------------------------
		getCurrentVdsGroup() {
			if (this.$route.params['groupId']) return this.$route.params['groupId']
			if (this.$store.state.vdsGroup.currentGroupId) return this.$store.state.vdsGroup.currentGroupId
			if (this.$store.state.vdsGroup.firstGroupId) return this.$store.state.vdsGroup.firstGroupId
			return ''
		},
		//---------------------------------------------------------------------
		// изменение опции пользователя по проигрыванию звука при нотификации
		//---------------------------------------------------------------------
		setVolume() {
			this.$store.commit('toggleAudioNitificationOption')
		},
		//---------------------------------------------------------------------
		// изменение опции пользователя по проигрыванию звука при нотификации
		// выбрали номер трека
		//---------------------------------------------------------------------
		setTrack(value) {
			// если тот же
			if (this.trackNo === value) return

			// сформируем наименование трека
			let _name = 'audioNotif_0' + String(value)
			// если такой трек есть
			if (this.$refs[_name])
			{
				// запоминаем номер трека локально
				this.trackNo = value
				// сброс обработчиков
				if (this.audio) this.audio.removeEventListener('canplay', this.audioCanPlay)
				// получим элемент "audio" заново
				this.audio = this.$refs[_name]
				// новый обработчик
				this.audio.addEventListener('canplay', this.audioCanPlay)
				// проиграем звук
				if (this.whatVolume)
				{
					this.audio.currentTime = 0
					try {
						this.audio.play().catch(() => {})
					}
					catch (e) {}
				}
				// сохраним его на сервере
				this.$store.commit('setAudioTrackNitificationOption', value)
			}
		},
		//---------------------------------------------------------------------
		// событие: можно проигрывать аудио
		//---------------------------------------------------------------------
		audioCanPlay() {
			this.canPlay = true
		},
		//---------------------------------------------------------------------
		// событие: изменились данные в Vuex об опциях пользователя
		//---------------------------------------------------------------------
		optionHandler() {
			// нас интересуют следующие опции
			// включен звук или нет
			this.whatVolume = Helper.normalizeBooleanValue(this.$store.state.userServerOptions.play_audio_on_notification)
			// если значения нет - это true
			if (!('play_audio_on_notification' in this.$store.state.userServerOptions))
				this.whatVolume = true

			// номер трека
			this.trackNo = parseInt(this.$store.state.userServerOptions.audio_track_on_notification, 10)
			if (isNaN(this.trackNo) || this.trackNo < 0 || this.trackNo > 5) this.trackNo = 0

			// название трека
			let _name = 'audioNotif_0' + this.trackNo
			if (this.$refs[_name])
			{
				// сброс обработчиков
				if (this.audio) this.audio.removeEventListener('canplay', this.audioCanPlay)
				// получим элемент "audio" заново
				this.audio = this.$refs[_name]
				// новый обработчик
				this.audio.addEventListener('canplay', this.audioCanPlay)
			}
		},
		//---------------------------------------------------------------------
		// событие: переход в форму создания персоны
		//---------------------------------------------------------------------
		gotoUrl(url) {
			// если есть доступ к sessionStorage
			if (window && window.sessionStorage)
			{
				// сохраним текущую форму в sessionStorage
				let _key = 'formSaver_' + this.$route.path.replace(/\//g, '_')
				window.sessionStorage.setItem(_key, JSON.stringify(this.formData))
			}

			// делаем непосредственно переход
			this.$router.push(url)
		},
		//---------------------------------------------------------------------
		// изменили вкладку шаблонов в создании VDS
		//---------------------------------------------------------------------
		onTemplateTab(tab) {
			// меням вкладку в данном компоненте
			this.activeCreateVdsTemplateTab = tab

			// если это не создание или вкладка не та
			if (this.crud !== 'vds') return
			if (tab !== 'backup' && tab !== 'iso') return

			// требуется подгрузка
			let _acc = null
			let _data = null

			// получим данные аккаунта и дата-центра
			let _field = this.findField('account_id')
			if (_field && _field.value)
				_acc = _field.value

			_field = this.findField('datacenter_id')
			if (_field && _field.value)
				_data = _field.value

			// подгружаем только если что то из них поменялось
			if (this.createVdsTemplateTabCache.tab !== tab ||
				this.createVdsTemplateTabCache.account_id !== _acc ||
				this.createVdsTemplateTabCache.datacenter_id !== _data)
			{
				// обновим кеш
				this.createVdsTemplateTabCache.tab = tab
				this.createVdsTemplateTabCache.account_id = _acc
				this.createVdsTemplateTabCache.datacenter_id = _data

				// эмулируем смену аккаунта (он есть у всех)
				this.$nextTick(() => this.reloadif('account_id'))
			}
		},
		//---------------------------------------------------------------------
		// требуется создание бэкапа
		//---------------------------------------------------------------------
		createBackup() {
			// если есть доступ к sessionStorage
			if (window && window.sessionStorage)
			{
				// получим данные
				let _data = {
					type: 'create'
				}
				// аккаунт
				let _accField = this.findField('account_id')
				if (_accField && _accField.value)
					_data['account_id'] = _accField.value

				// сохраним текущую форму в sessionStorage
				window.sessionStorage.setItem('create-backup', JSON.stringify(_data))
			}

			this.$router.push('/backups/list')
		},
		//---------------------------------------------------------------------
		// обработка Push-сообщений
		//---------------------------------------------------------------------
		pushMessageHandler(msg) {
			// разобъем сообщение на части
			let _parts = msg.split(' ')

			// если это пуш по email и мы в форме создания сертификата
			if (_parts && _parts[0] === 'update' && _parts[1] === 'email' && _parts[2] && _parts[2].indexOf('@') > 0 &&
				this.crud === 'certificate' && this.action === 'create')
			{
				// сразу получим email
				let _email = _parts[2]

				// проверим - именно в этой форме происходит создание сертификата
				// для домена указанного в email
				let _domain = _email.substring(_parts[2].indexOf('@') + 1)

				// найдем это поле
				let _field = this.findField('name')
				if (!_field) return

				// если это та форма
				if (_field['value'] === _domain)
				{
					// обнулим ошибку
					_field['_errMsg'] = ''

					// сабмитим форму
					this.submitForm()
				}
			}
		},
		//---------------------------------------------------------------------
		// обработчик события "storage"
		//---------------------------------------------------------------------
		onLocalStorageEvent(event) {
			// только для сотрудников
			if (this.$store.state.user_type !== 'admin') return
			// проверка события
			if (!event || event.key !== '__event' || !event.newValue) return

			if (event.newValue.indexOf('agf1') === 0 ||
				event.newValue.indexOf('agf0') === 0)
			{
				// сохраним данные формы
				let _key = 'formStorage_' + this.$route.path.replace(/\//g, '_')
				window.sessionStorage.setItem(_key, JSON.stringify(this.formData))

				// запрос счетчиков
				this.$store.dispatch('getTicketCounters')
				this.$store.dispatch('getRequestCounter')

				// просто запрашиваем данные заново
				this.requestData()
			}
		},
		//---------------------------------------------------------------------
		// изменился ли тариф-констуктор
		//---------------------------------------------------------------------
		handlePlanConstructorChanged(value) {
			this.isConstructPlanChanged = value
		},

		//---------------------------------------------------------------------
		// перегрузилось поле
		//---------------------------------------------------------------------
		handleCreateFieldReloaded(name) {
			// если в создании ВДС
			if (this.crud === 'vds' && this.action === 'create')
			{
				// изменился список тарифов
				if (name === 'plan_id')
				{
					// получим текущее значение
					this.$nextTick(() => {
						let plan = this.findField('plan_id')
						if (plan && plan.list && plan.list.length)
						{
							// может быть так что тарифный план не выбран
							// хотя список есть
							// но нужно перегрузить поля для бэкапов - например список ДЦ
							if (!plan.value && this.activeCreateVdsTemplateTab === 'backup')
							{
								// тогда берем первый тариф и загружаем с ним список ДЦ
								let firstValue = plan.list[0]['id']
								let dc = this.findField('datacenter_id')
								if (dc) this.reloadifLoading('plan_id', dc, firstValue)
							}
						}
					})
				}
			}
		},

		//---------------------------------------------------------------------
		// смена типа внешнего диска
		//---------------------------------------------------------------------
		onOuterDiskTypeChanged(value) {
			// перед сменой типа сохраним значения полей
			if (this.formData &&
				this.formData.fields &&
				this.formData.fields.length)
			{
				// сохраним только измененные поля
				this.outerDiskSavedFields = null
				const _changedFields = {}
				let _isNeedToSave = false

				for (let _idx in this.formData.fields) {
					const _row = this.formData.fields[_idx]
					if (!_row || !_row.length) continue

					for (let _jdx in _row) {
						const _field = _row[_jdx]
						if (!_field ||
							!('value' in _field) ||
							_field.type === 'header') {
							if (_field._field_name !== 'name' && _field._field_name !== 'backup_id')
							{
								continue
							}
						}

						_changedFields[_field._field_name] = {
							value: _field.value,
							visible: _field._visible
						}
						_isNeedToSave = true
					}
				}

				if (_isNeedToSave) {
					this.outerDiskSavedFields = _changedFields
				}
			}

			// меняем тип
			this.outerDiskTypeValue = value
			// ставим признак запроса формы для нового типа
			this.outerDiskRequestType = true
			// запросим форму снова
			this.requestData()
		},

		//---------------------------------------------------------------------
		// показ предупрежденияи выключении автопролонгации
		//---------------------------------------------------------------------
		onAutoprolongWarning() {
			this.generalDialogShow(
				'service/autoprolong',
				this.localeFtc('service/autoprolong_off'),
				this.localeFtc('main/detach'),
				() => {
					this.hideGeneralDialog()
					EventBus.$emit('w5-set-bool-field-value', {
						name: 'autoprolong',
						value: false
					})
				},
				1,
				true)
		},

		//---------------------------------------------------------------------
		// общий диалог
		//---------------------------------------------------------------------
		// закрытие диалога
		hideGeneralDialog() {
			EventBus.$emit('w5-body-scroll-enable')
			this.showGeneralDialog = false
			this.hideModalMask()
		},

		// генерация даилога
		generalDialogShow(title, text, buttonTitle, callback = null, style = 0, buttonCounter = false) {
			this.generalDialogTitle = title
			this.generalDialogText = text
			this.generalDialogButtonStyle = style
			this.generalDialogCallback = () => {
				if (this.generalDialogTimer > 0) return
				callback()
			}
			this.generalDialogButtonTitle = buttonTitle

			if (buttonCounter) {
				if (this.generalDialogTimerHandler) clearInterval(this.generalDialogTimerHandler)
				this.generalDialogTimer = 5
				this.generalDialogButtonTitle = '5 - ' + buttonTitle
			}

			// показываем диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showGeneralDialog = true

			// готовим таймер
			if (buttonCounter) {
				this.generalDialogTimerHandler = setInterval(() => {
					this.generalDialogTimer--
					this.generalDialogButtonTitle = this.generalDialogTimer + ' - ' + buttonTitle

					if (this.generalDialogTimer <= 0)
					{
						this.generalDialogButtonTitle = buttonTitle
						clearInterval(this.generalDialogTimerHandler)
						this.generalDialogTimerHandler = null
					}
				}, 1000)
			}
		},
		//---------------------------------------------------------------------
		// обсервер - изменение vieport
		//---------------------------------------------------------------------
		handleObserver(entries) {
			if (!entries || !entries.length) return
			if (this.$store.state.windowWidth <= 0 ||
				this.$store.state.windowWidth > 768)
			{
				return
			}

			entries.forEach(entry => {
				if (entry.isIntersecting)
				{
					this.isFormButtonFixed = false
				}
				else
				{
					this.isFormButtonFixed = true
				}
			})
		}

		//---------------------------------------------------------------------
	},
	//=========================================================================
	// наблюдаем переходы между CRUD внутри одного и того же компонента
	//=========================================================================
	watch: {
		'$route': function(to, from) {
			// запомним старые значения
			let _oldCrud = this.crud
			let _oldAction = this.action

			// инициируем основные данные, в частности и this.crud
			this.initData(to.path)

			// если произошла ли смена пути (CRUD или ACTION)
			if (_oldCrud !== this.crud || _oldAction !== this.action)
			{
				// обнулим закешированные данные
				this.formData = {
					title: ' '
				}
			}

			// теперь можно запросить данные
			if (this.crud) this.requestData()
		}
	},
	//=========================================================================
	// используемые компоненты
	//=========================================================================
	components: {
		Field,
		textSearch,
		notice,
		OuterDiskType
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style>
.form-with-divider {
	display: inline-block;
	margin-top: -30px;
	width: 100%;
}

/* ошибка поля */
div.w5-alert-valid {
	display: block;
	position: absolute;
	border-radius: 4px;
	color: red;
	background-color: #fec8c1;
	border: 1px solid #fe9c8f;
	font-size: 90%;
	font-weight: 300;
	padding: 4px 10px;
	margin-top: 6px;
	margin-bottom: 0;
	z-index: 13;
}

div.w5-alert-valid::before, div.w5-alert-valid::after {
	content: '';
	position: absolute;
	left: 20px;
	top: -9px;
	border: 4px solid transparent;
	border-bottom: 4px solid #fe9c8f;
}
div.w5-alert-valid::after {
	top: -7px;
	border-bottom: 4px solid #fec8c1;
}

div.w5-alert-valid.url-btn {
	left: 0;
	bottom: -20px;
}

/* предупреждение поля */
div.w5-alert-valid.warning {
	color: #333;
	background: #fff5ee;
	border: 1px solid #f9caa7;
}
div.w5-alert-valid.warning::before, div.w5-alert-valid.warning::after {
	border-bottom: 4px solid #f9caa7;
}
div.w5-alert-valid.warning::after {
	border-bottom: 4px solid #fff5ee;
}

div.w5-alert-valid.email-create {
	position: relative;	
}
div.w5-alert-valid.email-create:before, div.w5-alert-valid.email-create:after {
	content: none;
}

.w5-question-block {
	position: relative;
}

.w5-question {
	display: inline-block;
    height: 20px;
    line-height: 20px;
    width: 20px;
    text-align: center;
    border: 1px solid #ccc;
    border-radius: 10px;
    font-weight: 500;
    font-size: 13px;
    color: #ccc;
    transition: all 0.2s;
    cursor: pointer;
    user-select: none;
}

.w5-question:hover {
	border-color: #333;
	color: #333;
}

.shorty {
	width: 320px;
}

.w5-form-wrapper {
	/*max-width: 900px;*/
}

.w5-form-additional-info {
	margin: 10px 10px 10px 0;
    padding: 10px;
    font-size: 80%;
    border: 1px solid #eee;
    border-radius: 4px;
}


.w5-form-additional-info.snapshot {
	font-size: 95%;
	margin-top: 15px;
}

.w5-block-bordered-text {
	font-size: 90%;
	padding:0;
	margin:0;
}
.w5-block-bordered-text > ul {
	margin:0;
}

.w5-form-row.divider-field {
	position: relative;
	margin-top: 30px;
}
.w5-form-row.divider-field.first {
	margin-top: 0;
}

/*
.with-number-divider > .w5-field:not(.header):first-child {
	margin-left: 40px;
}
*/
.with-number-divider:not(.divider-field) {
	padding-left: 40px;
	margin-top: 0;
}

@media (max-width: 768px) {
	.with-number-divider:not(.divider-field) {
		padding-left: 0;
	}
}

.step-number-block {
	display: inline-block;
    width: 30px; height: 30px;
    border: 1px solid #2c8ad8;
    text-align: center;
    line-height: 28px;
    border-radius: 50%;
    margin-right: 10px;
    background-color: #2c8ad8;
    color: #fff;
    font-weight: 500;
}
.w5-application.mc .step-number-block {
	border: 1px solid #01196f;
	background-color: #01196f;
}

.notifier-track-wrapper {
	display: inline-block;
	margin-bottom: 10px;
}
.notifier-track {
	display: inline-block;
	font-weight: 500;
	font-size: 14px;
	background-color: #eee;
	padding: 10px 15px;
	border-radius: 4px;
	margin-right: 20px;
	cursor: pointer;
	transition: all 0.2s;
}
.notifier-track.switcher {
	padding: 10px;
}
.notifier-track:hover, .notifier-track.selected {
	color: white;
	background-color: #3ba3ff
}
.w5-application.mc .notifier-track:hover, .w5-application.mc .notifier-track.selected {
	background-color: #1b379c
}

@media (max-width: 767px) {
	div.w5-alert-valid {
		width: 100%;
	}

	.step-number {
		display: flex;
    	align-items: center;
		line-height: 1;
		font-size: 15px;
	}
	.step-number-block {
		float: left
	}
	
	.shorty {
		width: 100%;
	}

	.w5-form-additional-info {
		margin-right: 0;
	}

	.vds-create > .w5-field {
    	margin-left: 0;
    }

    .notifier-track-wrapper {
    	margin-top: 10px;
    	margin-bottom: 20px;
    }
    .notifier-track {
		margin-right: 12px;
	}
}

.w5-form-row.v-center {
	align-items: center
}

.app-link {
	display: inline-block;
	margin: 0 10px 0 5px;
	font-size: 12px;
	font-weight: 500;
	height: 48px;
	line-height: 48px;
	cursor: pointer;
}
.app-link:before {
	content: '';
	display: inline-block;
    position: relative;
    left: -5px;
    top: .5em;
	width: 20px;
	height: 20px;
	background-size: contain;
	background-position: center;
	background-repeat: no-repeat;
}
.app-link.google-play:before {	
	background-image: url(../../assets/img/google-play.svg);
}
.app-link.app-store:before {	
	background-image: url(../../assets/img/apple-app-store.svg);
}

img.qr {
	display: inline-block;
	margin-right: 20px;
	width: 130px;
	height: 130px;
	flex: 0 0 130px;
}

.w5-iso-form-notificator {
	position: fixed;
	top: 120px;
	left: 50%;
	margin-left: -100px;
	z-index: 10000;
	width: 200px;
	padding: 10px;
	text-align: center;
	font-size: 12px;
	transition: all .3s ease;
	border: 1px solid #5bc0de;
	border-radius: 4px;
	color: #fff;
	background-color: #5bc0de;
}

.w5-form-info {
	padding: 10px;
	border-radius: 4px;
	font-size: 90%;
	font-weight: 300;
	background: #fff5ee;
	background-color: rgb(255, 245, 238);
	border: 1px solid #f9caa7;
	z-index: 100;
	width: calc(100% - 2px);
	min-height: 45px;
	display: -ms-flexbox;
	display: flex;
	display: -webkit-flex;
	-ms-flex-align: center;
	align-items: center;
	-webkit-align-items: center;
}
.w5-form-info.warning {
	color: red;
	background-color: #fec8c1;
	border: 1px solid #fe9c8f;
}
.w5-form-info.in-form {
	width: calc(100% - 10px);
}

</style>



// WEBPACK FOOTER //
// Update.vue?73c422bf